import $ from 'jquery';
window.$ = window.jQuery = $;
import Quill from 'Quill';
let quill = null;
import 'sweetalert2/dist/sweetalert2.min.css';
import Swal from 'sweetalert2';
import { ninjaKey } from '../app';
let ninjaSliderKey = '';
$(document).ready(function() 
{
	ninjaSliderKey = ninjaKey();
});
$(document).ready(function() 
{
	let register = $('#registerpage').val();
	if(register == 'registerpage')
	{
		let data = localStorage.getItem('newsletterSubscriptionModal');
		localStorage.clear();
		if(data != null)
		{
			localStorage.setItem('newsletterSubscriptionModal',data);
		}

	}
});
$(document).ready(function() 
{
	$(".signuptype").click(function(e) 
	{
		localStorage.setItem("type", $("input[name='user_type']:checked").val());  
	});
});
$(document).ready(function() 
{
	$(".basicdetail").click(function(e) 
	{
		let isValid = true;
		let userType = $("input[name='user_type']:checked").val();
		let passwordsMatch = localStorage.getItem('passwordsMatch');
		if(userType == 'vendor')
		{
			let name  = $("#vname").val();
			if($("#vemail").val() == '' || name == '' || $(".vcats").val() == '' || $("#vpassword").val() == '' || $("#vcpassword").val() == '' )
			{
				Swal.fire({
				    title: 'Please Enter All Details',
				    icon: 'error',
				    confirmButtonText: 'OK'
				});
			}
			else
			{
				passwordValidation(passwordsMatch, userType, name)
				
			}
		}
		else
		{
			let name  = $("#name").val();
			if($("#femail").val() == '' || name == '' || $("#zipcode").val() == '' || $("#fpassword").val() == '' || $("#cpassword").val() == ''  || $("#city").val() == '' || $("#statedata").val() == '')
			{
				Swal.fire({
				    title: 'Please Enter All Details',
				    icon: 'error',
				    confirmButtonText: 'OK'
				});
			}
			else
			{
				passwordValidation(passwordsMatch, userType, name)
			}
		}
		
	});
});
function passwordValidation(passwordsMatch, userType, name)
{
	if(passwordsMatch == 'true')
	{
		agreementDetails(userType, name);
	}
	else
	{
		Swal.fire({
		    title: 'Your password is invalid',
		    text: 'Please enter a valid password according to specified conditions.',
		    icon: 'error',
		    confirmButtonText: 'OK'
		});
	}
}
$(document).on("click", ".quickAgreementAccept", function()
{
	let url = window.location.origin + '/login/google';
	window.location.href = url;
});
function agreementDetails(userType,name)
{
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url:  '/agreement/' + userType,
		type: 'POST',
		data: 	{
					'name' :name,
				},
		success: function(response)
		{
			$('#agreementModal').html(response.html);
			$('#agreementModal').modal("show");
		},
		error: function(jqXHR, textStatus, errorThrown, response)
		{
			alert('Internal error: ' + errorThrown);
		}
	}).done(function() 
	{
		setTimeout(function() 
		{
			$("#overlay").fadeOut(300);
		}, 500);
	});
}
$(document).on("click", ".agreementAccept", function(e)
{
	localStorage.setItem('agreementStatus',true);
	$('#agreementModal').modal("hide");
	let flag = 1;
	let email = '';
	let vendorType = localStorage.getItem("vendorType");
	localStorage.clear();
	if($("input[name='user_type']:checked").val() == 'invetor')
	{

		email = $("#femail").val();
		if(email != ' ' || email != '')
		{
			$(document).ajaxSend(function() 
			{
				$("#overlay").fadeIn(300);　
			});
			$.ajax(
			{
				headers: {
					'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
				url:  '/user/email/check',
				type: 'POST',
				data: 	{
							'email' :email,
							'type' :'inventor',
						},
				success: function(response)
				{
					if(response['status'] == 1)
					{
						Swal.fire({
						    title: 'This email account is already in use. Please use another email',
						    icon: 'warning',
						    confirmButtonText: 'OK'
						});
					}
					else
					{
						$('.basicdetail').addClass('next');
						localStorage.setItem("password", $("#fpassword").val());
						localStorage.setItem("email",email);
						localStorage.setItem("name", $("#name").val());  
						localStorage.setItem("add1", $("#addressone").val());  
						localStorage.setItem("add2", $("#addresstwo").val());  
						localStorage.setItem("add3", $("#addressthree").val());  
						localStorage.setItem("country", $("#countryzipdata").val());  
						localStorage.setItem("place", $("#places").val());  
						localStorage.setItem("city", $("#city").val());  
						localStorage.setItem("state", $("#statedata").val());  
						localStorage.setItem("zipcode", $("#zipcode").val()); 
						localStorage.setItem("UserRoleId", '2'); 
						localStorage.setItem("subscription", $("#flexCheckChecked").is(':checked'));  
						inventorCreate();
					}
				},
				error: function(jqXHR, textStatus, errorThrown, response)
				{
					alert('Internal error: ' + errorThrown);
				}
			}).done(function() 
			{
				setTimeout(function() 
				{
					$("#overlay").fadeOut(300);
				}, 500);
			});
		}
		else
		{
			alert("Please Enter Email Id");
			e.preventDefault();
		}
		
	}
	else
	{
		let email = $("#vemail").val();
		if(email != ' ' || email != '')
		{
			$(document).ajaxSend(function() 
			{
				$("#overlay").fadeIn(300);　
			});
			$.ajax(
			{
				headers: {
					'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
				url:  '/user/email/check',
				type: 'POST',
				data: 	{
							'email' :email,
							'type' :'vendor',
						},
				success: function(response)
				{
					if(response['status'] == 1)
					{
						flag = 0;
						Swal.fire({
						    title: 'This email account is already in use. Please use another email',
						    icon: 'warning',
						    confirmButtonText: 'OK'
						});
					}
					else
					{
						if(flag == 1)
						{
							let category = [];
							category.push($(".vcats").val());
							localStorage.setItem("email", $("#vemail").val());  
							localStorage.setItem("password", $("#vpassword").val()); 
							localStorage.setItem("password", $("#vcpassword").val()); 
							localStorage.setItem("name", $("#vname").val());  
							localStorage.setItem("category", JSON.stringify(category));  
							localStorage.setItem("referralCode", $("#referralCode").val());  
							
							let url = '';
							if(vendorType == 'free')
							{
							  	url = window.location.origin + '/free/vendor/sign-up';
							 			
							}
							else if(vendorType == 'pro')
							{
							  	url = window.location.origin + '/pro/vendor/sign-up';
							}
							else
							{
							  	url = window.location.origin + '/premium/vendor/sign-up';
							}
							window.location.href = url;
						}
					}
				},
				error: function(jqXHR, textStatus, errorThrown, response)
				{
					alert('Internal error: ' + errorThrown);
				}
			}).done(function() 
			{
				setTimeout(function() 
				{
					$("#overlay").fadeOut(300);
				}, 500);
			});
		}
		else
		{
			alert("Please Enter Email Id");
			e.preventDefault();
		}
		
		
	}

});
$(document).on("click", ".agreementCancel", function()
{
	localStorage.setItem('agreementStatus',false);
	$('#agreementModal').modal("hide");
	$("#errorMessage").html("Please accept the agreement for sign-up");
});
$(document).on("click", ".socialSignUpBtn", function()
{
	let userType = 'inventor';
	let name  = 'anonymous';
	agreementDetails(userType,name);
		
});
$(document).on("click", ".editlayouttype", function()
{
	let id = $(this).attr("data-id");
	localStorage.setItem("layout", id);
	$("#overlay").fadeIn(300);
	let name = localStorage.getItem("name");
	let email = localStorage.getItem("email");
	let tagline  = localStorage.getItem("Tagline");
	let password = localStorage.getItem("password");
	let content = [];
	let media_id = [];
	media_id = localStorage.getItem("allfiles");
	let sliderfile = [];
	sliderfile = localStorage.getItem("sliderfiles");
	let deletetestimonialtdata = [];
	let testdata = JSON.parse(localStorage.getItem("allEntries"));
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let description = localStorage.getItem("Description");
	let category = [];
	category = localStorage.getItem("category");
	content = testdata;
	let downloaddelete = [];
	downloaddelete = JSON.parse(localStorage.getItem("deletedownloadfiles"));
	deletetestimonialtdata = JSON.parse(localStorage.getItem("deletetestimonialEntries"));
	let download = [];
	download = JSON.parse(localStorage.getItem("Alldownloadfiles"));
	let portfoliodata = JSON.parse(localStorage.getItem("allportfolioentries"));
	$.ajax(
	{
		headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url:  '/vendor/layout/' + id,
		type: 'POST',
		data: {
			"tagline" : tagline,
			"portfoliodata": portfoliodata,
			"sliderfile": sliderfile,
			"category": category,
			"password": password,
			"email": email,
			"name": name,
			"title": title,
			"description": description,
			"address": address,
			"media_id": media_id,
			"downloaddelete": downloaddelete,
			"download": download,
			"content": content,
			"deletetestimonialtdata": deletetestimonialtdata
		},
		dataType: 'json',
		success: function(response)
		{
			$('#editlayoutblock').html(response.html);
			 quill = new Quill('.editor', {
				modules: {
					toolbar: [
						[{
							header: [1, 2, 3, 4, 5, 6, false]
						}],
						[{
							'color': []
						}, {
							'background': []
						}],
						[{
							'list': 'ordered'
						}, {
							'list': 'bullet'
						}],
						['bold', 'italic', 'underline', 'link'],
						['image'],
						['video'],
					]
				},
				placeholder: 'Content here...',
				theme: 'snow' // or 'bubble'
			});
			let name = $('#editorDescriptionContent').val();
			if(name != undefined)
			{
				quill.setContents(JSON.parse(name));
			}
			/* Ninja Slider Video Plugin v2016.12.27. Copyright www.menucool.com */
			"use strict";var LIS_VMs=[],LIS_YTs=[];function nsVideoPlugin(){for(var c=this.getLis(),b=0;b<c.length;b++)for(var e=c[b].getElementsByTagName("*"),d=0;d<e.length;d++)if(e[d].className=="video"){var a=e[d].getElementsByTagName("iframe");if(a.length){a=a[0];c[b].player=a;var h=a.src.toLowerCase();if(h.indexOf("player.vimeo")!=-1){a.tp="VM";LIS_VMs.push(c[b])}else if(h.indexOf("youtube.com")!=-1){a.tp="YT";LIS_YTs.push(c[b])}}else{a=e[d].getElementsByTagName("video");if(!a.length)a=e[d].getElementsByTagName("audio");if(a.length){a=a[0];c[b].player=a;a.tp="VA";addVAEventHandlers(this,a)}}var g=this;if(c[b].player){c[b].onclick=function(){g.playVideo&&g.playVideo(this.player)};if(c[b].player.tp!="VA"){var f=document.createElement("div");f.className="stopVideoIcon";f.onclick=function(a){g.unloadPlayer();a.stopPropagation()};e[d].appendChild(f)}}}addVimeoEventHandlers(this);addYoutubeEventHandlers(this);this.playVideo=function(a,b){this.iframe!=a&&this.unloadPlayer();if(!b)b=0;setSliderWhenOnPlay(this);switch(a.tp){case"VM":if(this.playVideo_VM)this.playVideo_VM(a);else if(b<25){var c=this;setTimeout(function(){c.playVideo(a,++b)},500)}else this.next();break;case"YT":if(this.playVideo_YT)this.playVideo_YT(a);else if(b<25){var c=this;setTimeout(function(){c.playVideo(a,++b)},500)}else this.next();break;default:this.playVideo_VA(a)}};this.playAutoVideo=function(a){if(a.player){var c=a.player.getAttribute("data-autoplay"),b=0;if(c=="true")b=1;else if(c=="1"&&!a.player.AP){b=1;a.player.AP=1}if(b){this.stop();this.playVideo(a.player)}}};this.unloadPlayer=function(){var a=this.iframe;if(a){a.parentNode.style.zIndex="auto";switch(a.tp){case"VM":this.unloadPlayer_VM(a);break;case"YT":this.unloadPlayer_YT(a);break;default:this.unloadPlayer_VA(a)}}};this.setIframeSize=function(){for(var e=this.getLis(),d=0;d<e.length;d++){var a=e[d].player;if(a){var c=a.getAttribute("data-width");if(c)var b=a.getAttribute("data-height");else{var f=a.parentNode.parentNode.parentNode;c=f.offsetWidth;b=f.offsetHeight}a.setAttribute("width",c);b&&a.setAttribute("height",b)}}};this.setIframeSize()}function addEvent(a,c,b){if(a.addEventListener)a.addEventListener(c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)}function setSliderWhenOnPlay(a){a.stop();a.iframe=a.getLis()[a.getIndex()].player;set_ZIndex(a.iframe,1)}function set_ZIndex(a,b){a.parentNode.style.zIndex=b?"2147481964":"auto"}function extendSliderFunForVimeo(){this.postToIframe=function(a,d,b){this.iframe=a;if(window.JSON){var c={method:d};if(b)c.value=b;this.iframe.contentWindow.postMessage(JSON.stringify(c),a.getAttribute("src").split("?")[0])}};this.playVideo_VM=function(a){if(LIS_VMs.Rdy)this.postToIframe(a,"play");else{var b=this;setTimeout(function(){b.postToIframe(a,"play")},300)}};this.unloadPlayer_VM=function(a){window.JSON&&a.contentWindow.postMessage(JSON.stringify({method:"pause"}),a.getAttribute("src").split("?")[0])};this.backToStartFrame=function(){if(this.iframe&&window.JSON)this.iframe.src=this.iframe.getAttribute("src")}}function addVimeoEventHandlers(a){if(LIS_VMs.length){extendSliderFunForVimeo.call(a);addEvent(window,"message",d);function d(a){if(!/^https?:\/\/player.vimeo.com/.test(a.origin))return false;var b=JSON.parse(a.data);switch(b.event){case"ready":f();break;case"play":g();break;case"finish":e()}}function f(){b("addEventListener","play");b("addEventListener","finish");LIS_VMs.Rdy=1}function b(d,a){if(window.JSON){var e={method:d};if(a)e.value=a;for(var b=0;b<LIS_VMs.length;b++)c(d,a,LIS_VMs[b].player)}}function c(d,b,a){var c={method:d};if(b)c.value=b;a.contentWindow.postMessage(JSON.stringify(c),a.getAttribute("src").split("?")[0])}function g(){setSliderWhenOnPlay(a)}function e(){if(a.iframe==a.getLis()[a.getIndex()].player){set_ZIndex(a.iframe,0);a.backToStartFrame();setTimeout(function(){a.next()},120)}}}}function addYoutubeEventHandlers(c){if(LIS_YTs.length){var d=document.createElement("script");d.src="https://www.youtube.com/iframe_api";var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(d,b);window._zSlider=c;c.unloadPlayer_YT=function(a){var b=a.parentNode.parentNode.yplayer;if(b&&typeof b.pauseVideo=="function")b.pauseVideo();else{a.src=a.getAttribute("src");a.parentNode.parentNode.yplayer=new YT.Player(a.id,{events:{onStateChange:onYTPlayerStateChange}})}};for(var a=0;a<LIS_YTs.length;a++)LIS_YTs[a].player.src+="&origin="+location.protocol+"//"+location.hostname+(location.port?":"+location.port:"")}}function onYTPlayerStateChange(a){if(a.data==1)setSliderWhenOnPlay(_zSlider);else if(a.data==0){setTimeout(function(){_zSlider.iframe.src=_zSlider.iframe.getAttribute("src");_zSlider.iframe.parentNode.parentNode.yplayer=new YT.Player(_zSlider.iframe.id,{events:{onStateChange:onYTPlayerStateChange}})},500);_zSlider.next()}}function onYouTubePlayerAPIReady(){for(var c=_zSlider.getLis(),a=0;a<c.length;a++){var b=c[a].player;if(b&&b.tp=="YT"){b.id=_zSlider.sliderId+"-ifr"+a;c[a].yplayer=new YT.Player(b.id,{events:{onStateChange:onYTPlayerStateChange}})}}_zSlider.playVideo_YT=function(a){if(a.parentNode.parentNode.yplayer)if(typeof a.parentNode.parentNode.yplayer.playVideo=="function")a.parentNode.parentNode.yplayer.playVideo();else setTimeout(function(){_zSlider.playVideo_YT(a)},100)}}function extendSliderFunForhtml5VA(){this.playVideo_VA=function(a){a.play&&a.play()};this.unloadPlayer_VA=function(a){a.pause&&a.pause()}}function addVAEventHandlers(c,a){!c.playVideo_VA&&extendSliderFunForhtml5VA.call(c);var b={handleEvent:function(a){a.preventManipulation&&a.preventManipulation();switch(a.type){case"click":a.stopPropagation();break;case"play":this.play();break;case"ended":this.ended();break;case"loadedmetadata":this.loaded()}},play:function(){setSliderWhenOnPlay(c)},ended:function(){set_ZIndex(a,0);c.next()},loaded:function(){}};addEvent(a,"click",b);addEvent(a,"play",b);addEvent(a,"ended",b);addEvent(a,"loadedmetadata",b)}
			var nsOptions =
			{
			    sliderId: "ninja-slider",
			    transitionType: "fade",
			    autoAdvance: true,
			    rewind: true,
			    n: true,
			    m: true,
			    delay: "10000",
			    transitionSpeed: 5000,
			    aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
			    initSliderByCallingInitFunc: false,
			    shuffle: false,
			    startSlideIndex: 0, //0-based
			    navigateByTap: false,
			    pauseOnHover: false,
			    keyboardNav: true,
			    before: null,
			    license: ninjaSliderKey
			};
			var nslider = new NinjaSlider(nsOptions);
			/* Ninja Slider v2016.12.29 Copyright www.menucool.com */
			function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
			$("#overlay").fadeOut(300);
		},
		error: function(jqXHR, textStatus, errorThrown, response)
		{
			alert('Internal error: ' + errorThrown);
		}
	});
	$("#overlay").fadeOut(300);
});
//layout change
$(document).on("click", ".layoutchangetype", function()
	{
		let name = localStorage.getItem("name");
		let email = localStorage.getItem("email");
		let password = localStorage.getItem("password");
		let content = [];
		let media_id = [];
		media_id = localStorage.getItem("allfiles");
		let sliderfile = [];
		sliderfile = localStorage.getItem("sliderfiles");
		let deletetestimonialtdata = [];
		let testdata = JSON.parse(localStorage.getItem("allEntries"));
		let address = JSON.parse(localStorage.getItem("addressData"));
		let title = localStorage.getItem("Title");
		let Tagline = localStorage.getItem("Tagline");
		let description = localStorage.getItem("Description");
		let category = [];
		category = localStorage.getItem("category");
		content = testdata;
		let downloaddelete = [];
		downloaddelete = JSON.parse(localStorage.getItem("deletedownloadfiles"));
		deletetestimonialtdata = JSON.parse(localStorage.getItem("deletetestimonialEntries"));
		let download = [];
		download = JSON.parse(localStorage.getItem("Alldownloadfiles"));
		let portfoliodata = JSON.parse(localStorage.getItem("allportfolioentries"));
		let layout = $(this).attr("data-id");
		localStorage.setItem("layout", layout);
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url:  '/vendor/premium/layout',
			type: 'POST',
			data: {
					"portfoliodata": portfoliodata,
					"sliderfile": sliderfile,
					"category": category,
					"password": password,
					"email": email,
					"name": name,
					"title": title,
					"description": description,
					"address": address,
					"media_id": media_id,
					"downloaddelete": downloaddelete,
					"download": download,
					"content": content,
					"deletetestimonialtdata": deletetestimonialtdata,
					"Tagline": Tagline,
					"layout": layout

			},
			success: function(response)
			{
				$('.layoutchange').html(response.html);
				 quill = new Quill('.editor', {
					modules: {
						toolbar: [
							[{
								header: [1, 2, 3, 4, 5, 6, false]
							}],
							[{
								'color': []
							}, {
								'background': []
							}],
							[{
								'list': 'ordered'
							}, {
								'list': 'bullet'
							}],
							['bold', 'italic', 'underline', 'link'],
							['image'],
							['video'],
						]
					},
					placeholder: 'Content here...',
					theme: 'snow' // or 'bubble'
				});
				let name = $('#decriptioncontent').val();
				if(name != undefined)
				{
					quill.setContents(JSON.parse(name));
				}
				/* Ninja Slider Video Plugin v2016.12.27. Copyright www.menucool.com */
				"use strict";var LIS_VMs=[],LIS_YTs=[];function nsVideoPlugin(){for(var c=this.getLis(),b=0;b<c.length;b++)for(var e=c[b].getElementsByTagName("*"),d=0;d<e.length;d++)if(e[d].className=="video"){var a=e[d].getElementsByTagName("iframe");if(a.length){a=a[0];c[b].player=a;var h=a.src.toLowerCase();if(h.indexOf("player.vimeo")!=-1){a.tp="VM";LIS_VMs.push(c[b])}else if(h.indexOf("youtube.com")!=-1){a.tp="YT";LIS_YTs.push(c[b])}}else{a=e[d].getElementsByTagName("video");if(!a.length)a=e[d].getElementsByTagName("audio");if(a.length){a=a[0];c[b].player=a;a.tp="VA";addVAEventHandlers(this,a)}}var g=this;if(c[b].player){c[b].onclick=function(){g.playVideo&&g.playVideo(this.player)};if(c[b].player.tp!="VA"){var f=document.createElement("div");f.className="stopVideoIcon";f.onclick=function(a){g.unloadPlayer();a.stopPropagation()};e[d].appendChild(f)}}}addVimeoEventHandlers(this);addYoutubeEventHandlers(this);this.playVideo=function(a,b){this.iframe!=a&&this.unloadPlayer();if(!b)b=0;setSliderWhenOnPlay(this);switch(a.tp){case"VM":if(this.playVideo_VM)this.playVideo_VM(a);else if(b<25){var c=this;setTimeout(function(){c.playVideo(a,++b)},500)}else this.next();break;case"YT":if(this.playVideo_YT)this.playVideo_YT(a);else if(b<25){var c=this;setTimeout(function(){c.playVideo(a,++b)},500)}else this.next();break;default:this.playVideo_VA(a)}};this.playAutoVideo=function(a){if(a.player){var c=a.player.getAttribute("data-autoplay"),b=0;if(c=="true")b=1;else if(c=="1"&&!a.player.AP){b=1;a.player.AP=1}if(b){this.stop();this.playVideo(a.player)}}};this.unloadPlayer=function(){var a=this.iframe;if(a){a.parentNode.style.zIndex="auto";switch(a.tp){case"VM":this.unloadPlayer_VM(a);break;case"YT":this.unloadPlayer_YT(a);break;default:this.unloadPlayer_VA(a)}}};this.setIframeSize=function(){for(var e=this.getLis(),d=0;d<e.length;d++){var a=e[d].player;if(a){var c=a.getAttribute("data-width");if(c)var b=a.getAttribute("data-height");else{var f=a.parentNode.parentNode.parentNode;c=f.offsetWidth;b=f.offsetHeight}a.setAttribute("width",c);b&&a.setAttribute("height",b)}}};this.setIframeSize()}function addEvent(a,c,b){if(a.addEventListener)a.addEventListener(c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)}function setSliderWhenOnPlay(a){a.stop();a.iframe=a.getLis()[a.getIndex()].player;set_ZIndex(a.iframe,1)}function set_ZIndex(a,b){a.parentNode.style.zIndex=b?"2147481964":"auto"}function extendSliderFunForVimeo(){this.postToIframe=function(a,d,b){this.iframe=a;if(window.JSON){var c={method:d};if(b)c.value=b;this.iframe.contentWindow.postMessage(JSON.stringify(c),a.getAttribute("src").split("?")[0])}};this.playVideo_VM=function(a){if(LIS_VMs.Rdy)this.postToIframe(a,"play");else{var b=this;setTimeout(function(){b.postToIframe(a,"play")},300)}};this.unloadPlayer_VM=function(a){window.JSON&&a.contentWindow.postMessage(JSON.stringify({method:"pause"}),a.getAttribute("src").split("?")[0])};this.backToStartFrame=function(){if(this.iframe&&window.JSON)this.iframe.src=this.iframe.getAttribute("src")}}function addVimeoEventHandlers(a){if(LIS_VMs.length){extendSliderFunForVimeo.call(a);addEvent(window,"message",d);function d(a){if(!/^https?:\/\/player.vimeo.com/.test(a.origin))return false;var b=JSON.parse(a.data);switch(b.event){case"ready":f();break;case"play":g();break;case"finish":e()}}function f(){b("addEventListener","play");b("addEventListener","finish");LIS_VMs.Rdy=1}function b(d,a){if(window.JSON){var e={method:d};if(a)e.value=a;for(var b=0;b<LIS_VMs.length;b++)c(d,a,LIS_VMs[b].player)}}function c(d,b,a){var c={method:d};if(b)c.value=b;a.contentWindow.postMessage(JSON.stringify(c),a.getAttribute("src").split("?")[0])}function g(){setSliderWhenOnPlay(a)}function e(){if(a.iframe==a.getLis()[a.getIndex()].player){set_ZIndex(a.iframe,0);a.backToStartFrame();setTimeout(function(){a.next()},120)}}}}function addYoutubeEventHandlers(c){if(LIS_YTs.length){var d=document.createElement("script");d.src="https://www.youtube.com/iframe_api";var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(d,b);window._zSlider=c;c.unloadPlayer_YT=function(a){var b=a.parentNode.parentNode.yplayer;if(b&&typeof b.pauseVideo=="function")b.pauseVideo();else{a.src=a.getAttribute("src");a.parentNode.parentNode.yplayer=new YT.Player(a.id,{events:{onStateChange:onYTPlayerStateChange}})}};for(var a=0;a<LIS_YTs.length;a++)LIS_YTs[a].player.src+="&origin="+location.protocol+"//"+location.hostname+(location.port?":"+location.port:"")}}function onYTPlayerStateChange(a){if(a.data==1)setSliderWhenOnPlay(_zSlider);else if(a.data==0){setTimeout(function(){_zSlider.iframe.src=_zSlider.iframe.getAttribute("src");_zSlider.iframe.parentNode.parentNode.yplayer=new YT.Player(_zSlider.iframe.id,{events:{onStateChange:onYTPlayerStateChange}})},500);_zSlider.next()}}function onYouTubePlayerAPIReady(){for(var c=_zSlider.getLis(),a=0;a<c.length;a++){var b=c[a].player;if(b&&b.tp=="YT"){b.id=_zSlider.sliderId+"-ifr"+a;c[a].yplayer=new YT.Player(b.id,{events:{onStateChange:onYTPlayerStateChange}})}}_zSlider.playVideo_YT=function(a){if(a.parentNode.parentNode.yplayer)if(typeof a.parentNode.parentNode.yplayer.playVideo=="function")a.parentNode.parentNode.yplayer.playVideo();else setTimeout(function(){_zSlider.playVideo_YT(a)},100)}}function extendSliderFunForhtml5VA(){this.playVideo_VA=function(a){a.play&&a.play()};this.unloadPlayer_VA=function(a){a.pause&&a.pause()}}function addVAEventHandlers(c,a){!c.playVideo_VA&&extendSliderFunForhtml5VA.call(c);var b={handleEvent:function(a){a.preventManipulation&&a.preventManipulation();switch(a.type){case"click":a.stopPropagation();break;case"play":this.play();break;case"ended":this.ended();break;case"loadedmetadata":this.loaded()}},play:function(){setSliderWhenOnPlay(c)},ended:function(){set_ZIndex(a,0);c.next()},loaded:function(){}};addEvent(a,"click",b);addEvent(a,"play",b);addEvent(a,"ended",b);addEvent(a,"loadedmetadata",b)}
					var nsOptions =
				  	{
					  sliderId: "ninja-slider",
					  transitionType: "fade",
					  autoAdvance: true,
					  rewind: true,
					  delay: 10000,
					  transitionSpeed: 5000,
					  aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
					  initSliderByCallingInitFunc: false,
					  shuffle: false,
					  startSlideIndex: 0, //0-based
					  navigateByTap: false,
					  pauseOnHover: false,
					  keyboardNav: true,
					  before: null,
					  license: ninjaSliderKey
				  };
				  var nslider = new NinjaSlider(nsOptions);//function call
				  function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
				
			},
			error: function(jqXHR, textStatus, errorThrown, response)
			{
				alert('Internal error: ' + errorThrown);
			}
		}).done(function() 
		{
			setTimeout(function() 
			{
				$("#overlay").fadeOut(300);
			}, 500);
		});

	});
//vendor plan select
$(document).ready(function() 
{
	$(".vendorplan").click(function(e) 
	{
		localStorage.setItem("vendorType", $(this).attr("data-type"));  

	});
});

$(document).on("click", ".descsave", function()
{
    let quilldesc = JSON.stringify(quill.getContents());
    let  desc= quill.root.innerHTML;
    $('#desc').html(desc);
    localStorage.setItem("Description",quilldesc);
    $('#descriptionbox').modal("hide");
});

function inventorCreate(e)
{
	let formData = new FormData();
	formData.append('email',localStorage.getItem("email"));
	formData.append("password", localStorage.getItem("password"));  
	formData.append("uname", localStorage.getItem("name"));  
	let add1 = null;
	let add2 = null;
	let add3 = null;
	if(localStorage.getItem("add1") != undefined)
	{

		add1 = localStorage.getItem("add1");
	}
	
	if(localStorage.getItem("add2") != undefined)
	{
		add2 = localStorage.getItem("add2");
	}
	if(localStorage.getItem("add3") != undefined)
	{
		add3 = localStorage.getItem("add3");
	}
	formData.append("Address1", add1);  
	formData.append("Address2", add2);  
	formData.append("Address3", add3);  
	formData.append("country", localStorage.getItem("country"));  
	formData.append("places", localStorage.getItem("place"));  
	formData.append("city", localStorage.getItem("city"));  
	formData.append("state", localStorage.getItem("state"));  
	formData.append("UserRoleId", localStorage.getItem("UserRoleId"));  
	formData.append("zipcode", localStorage.getItem("zipcode")); 
	formData.append("newsemail", localStorage.getItem("subscription"));  
	formData.append("_token", $("input[name='_token']").val());  
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		headers: {
		'X-CSRF-Token': $("input[name='_token']").val()
		},
		url:  '/inventor-sign-up' ,
		type: 'POST',
		data: formData,
		contentType: false,
		processData: false,
		dataType: 'json',
		//enctype     : "multipart/form-data",   //it is done inside jquery
		success: function(response)
		{
			//alert("Your account has been created successfully");
			let url = 'email/verify';
			window.location.href = url ;
		},
		/*error: function (jqXHR, textStatus, errorThrown,response) 
		{
			alert('Internal error: ' + errorThrown);
		},*/
	}).done(function() 
	{
		setTimeout(function() 
		{
			$("#overlay").fadeOut(300);
		}, 500);
	});			
}
/*$(document).ready(function() 
{
	$(".imageupload").click(function(e) 
	{
		//localStorage.setItem("fileToUpload[]", document.getElementById('upload-file').files[0]);  
		let formData = new FormData();
		formData.append('email',localStorage.getItem("email"));
		formData.append("password", localStorage.getItem("password"));  
		formData.append("uname", localStorage.getItem("name"));  
		formData.append("Address1", localStorage.getItem("add1"));  
		formData.append("Address2", localStorage.getItem("add2"));  
		formData.append("Address3", localStorage.getItem("add3"));  
		formData.append("country", localStorage.getItem("country"));  
		formData.append("city", localStorage.getItem("city"));  
		formData.append("state", localStorage.getItem("state"));  
		formData.append("UserRoleId", localStorage.getItem("UserRoleId"));  
		formData.append("zipcode", localStorage.getItem("zipcode")); 
		formData.append("newsemail", localStorage.getItem("subscription"));  
		formData.append("_token", $("input[name='_token']").val());  
		$.ajax(
		{
			headers: {
			'X-CSRF-Token': $("input[name='_token']").val()
			},
			url:  '/inventor-sign-up' ,
			type: 'POST',
			data: formData,
			contentType: false,
			processData: false,
			dataType: 'json',
			//enctype     : "multipart/form-data",   //it is done inside jquery
			success: function(response)
			{
				alert("Your account has been created successfully");
				let url = 'inventor/login';
				window.location.href = url ;
			},
			error: function (jqXHR, textStatus, errorThrown,response) 
			{
				alert('Internal error: ' + errorThrown);
			},
		});
	});
});
*/
//Country change with states
$(document).on('change', '#countrydata',function()
{
	var cid = $(this).val();
	if(cid)
	{
		$.ajax(
		{
			type:"get",
			url:'/getStates/'+cid,
			success:function(res)
			{
				if(res)
				{
					$("#statedata").empty();
					$("#city").empty();
					$("#places").empty();
					$("#statedata").append('<option>Select State</option>');
					$.each(res,function(key,value)
					{
						$("#statedata").append('<option value="'+value+'">'+key+'</option>');
					});
				}
			}
		});
	}
});
$(document).on('change', '.addcountrydata',function()
{
	var cid = $(this).val();
	if(cid)
	{
		$.ajax(
		{
			type:"get",
			url:'/getStates/'+cid,
			success:function(res)
			{
				if(res)
				{
					$(".statedata").empty();
					$(".city").empty();
					$(".statedata").append('<option>Select State</option>');
					$.each(res,function(key,value)
					{
						$(".statedata").append('<option value="'+value+'">'+key+'</option>');
					});
				}
			}
		});
	}
});
$(document).on('click', '.editinventorprofile',function()
{
	let id = $(this).data('id');
	$.ajax(
	{
		url:  '/inventor/editaddress/' + id,
		type: 'GET',
		dataType: 'json',
		success: function(response)
		{
			$('.ajaxeditprofile').html(response.html);
			$('#editprofile').modal("show");
		}
	});
});
//state change with cities
$(document).on('change', '#statedata',function()
{
	var sid = $(this).val();
	if(sid)
	{
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			type:"get",
			url:  '/getCities/'+sid,
			success:function(res)
			{
				if(res)
				{
					$("#city").empty();
					$("#places").empty();
					$("#city").append('<option>Select City</option>');
					$.each(res,function(key,value)
					{
						$("#city").append('<option value="'+value+'">'+key+'</option>');
					});
				}
			}
		}).done(function() 
  		{
  			setTimeout(function() 
  			{
  				$("#overlay").fadeOut(300);
  			}, 500);
  		});
	}
});

$(document).on('change', '.statedata',function()
{
	var sid = $(this).val();
	if(sid)
	{
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			type:"get",
			url:  '/getCities/'+sid,
			success:function(res)
			{
				if(res)
				{
					$(".city").empty();
					$(".city").append('<option>Select City</option>');
					$.each(res,function(key,value)
					{
						$(".city").append('<option value="'+value+'">'+key+'</option>');
					});
				}
			}
		}).done(function() 
  		{
  			setTimeout(function() 
  			{
  				$("#overlay").fadeOut(300);
  			}, 500);
  		});
	}
});
//city change for place 
$(document).on('change', '.cityZip',function()
{
	var cid = $(this).val();
	let country = $("#countryzipdata").val();
	let state = $("#statedata").val();
	if(cid)
	{
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			headers: 
			{
			   'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			type:"post",
			url:  '/getPlaces/'+cid,
			data :{'country':country, 'state':state},
			success:function(res)
			{
				if(res)
				{
					$("#places").empty();
					$.each(res,function(key,value)
					{
						$("#places").append('<option value="'+value+'">'+key+'</option>');
					});
				}
			}
		}).done(function() 
  		{
  			setTimeout(function() 
  			{
  				$("#overlay").fadeOut(300);
  			}, 500);
  		});
	}
});

$(document).on("click", ".addvendorprofile", function()
{
	let addressData = localStorage.getItem('addressData');
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		headers: 
		{
		   'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/vendor/address',
		type: 'POST',
		data: {"addressData" : addressData },
		dataType: 'json',
		success: function(response)
		{
			$('.ajaxeditprofile').html(response.html);
			$('#editprofile').modal("show");

		}
	}).done(function() 
   	{
 		setTimeout(function()
 		{
  			$("#overlay").fadeOut(300);
 		},500);
 	});
});

$(document).on("click", ".newaddresssave", function()
{
    localStorage.setItem('vendorkey',true);
 	let add1      = $("#Address1").val();
 	let add2      = $("#Address2").val();
 	let add3      = $("#Address3").val();
 	let country   = $("#countryzipdata").val();
 	let aid       = $("#aid").val();
 	let state     = $("#statedata").val();
 	let place     = $("#places").val();
 	let countryName   = $('#countryzipdata').find('option:selected').text();
 	let placeName    = $('#places').find('option:selected').text();
 	let stateName    = $('#statedata').find('option:selected').text();
 	let city      = $("#city").val();
 	let cityName     =  $('#city').find('option:selected').text();
 	let pincode   = $("#zipcode").val();
 	let test_rows = [];
 	let  test_line = {};
 	test_line.add1 = add1;
 	test_line.aid = aid;
 	test_line.add2 = add2;
 	test_line.add3 = add3;
 	test_line.country = country;
 	test_line.state = state;		
 	test_line.city = city;
 	test_line.place = place;
 	test_line.pincode = pincode;
 	test_rows.push(test_line);
 	localStorage.setItem("addressData",JSON.stringify(test_rows));
 	$("#edit_vendor_address").html(placeName+', '+stateName+', '+countryName + ' - '+pincode);
 	$('#editprofile').modal("hide");
});

//Free Vendor 


$(document).on("click", ".logintesting", function()
{
	localStorage.setItem('islogin', 'yes');
});
$(document).on("click", ".loginBtn", function()
{
	$('#loginModal').modal("show");
});
$(document).on("click", ".vendorLogin", function()
{
	let cid=$("#cid").val($(this).data('cid'));
	let cuuid=$("#login-cuuid").val($(this).data('cuuid'));
	let slug=$("#slug").val($(this).data('slug'));
	let type=$("#type").val($(this).data('type'));
	$('#loginModal').modal("show");
});
$(document).on("click", ".categoryLogin", function()
{
	let categorySlug=$("#categorySlug").val($(".categoryLogin").data('category-slug'));
	$('#loginModal').modal("show");
});
$(document).on("submit", "#loginForm", function(event)
{
	let slug = $("#slug").val();
	let categorySlug = $("#categorySlug").val();
	event.preventDefault();
	let formData = $(this).serialize();
	let loginRoute = $('#loginForm').data('route');
	$.ajax(
	{
    	url: loginRoute,
    	type: 'POST',
    	data: formData,
    	dataType: 'json',
    	success: function (response) 
    	{
    		if(slug.trim() !== '' || categorySlug.trim() !== '')
    		{
    			if (response.redirect_url) 
	    		{
	                window.open(response.redirect_url, '_blank');
	            }
	            window.location.reload();
    		}
    		else
    		{
				window.location.href = response.redirect_url;
    		}
    		
    	},
    	error: function (xhr, status, error) 
    	{
    		if (xhr.responseJSON && xhr.responseJSON.error) 
    		{
                const errorMessage = xhr.responseJSON.error;
                $(".errorMessage").html(errorMessage);
                $(".errorMessage").css("display","block");
            } 
            else 
            {
                alert('An error occurred'); // Fallback error message
            }
    	}
    });

});

function storageChange (event) 
{
	let url = window.location.origin +'/login/form';
	if(event.key === 'islogin') 
	{
		if(url != window.location.pathname)
		{
			window.location.reload();
		}
	    
	}
}
window.addEventListener('storage', storageChange, false)
$(document).on("click", "#savefreevendor", function()
{
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	let name = localStorage.getItem("name");
	let email = localStorage.getItem("email");
	let password = localStorage.getItem("password");
	let referralCode = localStorage.getItem("referralCode");
	let content = [];
	let media_id = [];
	media_id = localStorage.getItem("allfiles"); 
	let sliderfile = [];
	sliderfile = localStorage.getItem("sliderfiles"); 
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let description = localStorage.getItem("Description");
	let category = [];
	category = localStorage.getItem("category");
	//content = testdata;
	let downloaddelete = []; 
	if(name == null || email == null || password ==null)
	{
	 	alert("Name, email and password are required to create an account");
	}
	else
	{
	 	if(title != null && address != null && description != null && sliderfile != null)
	 	{
	  		$.ajax(
	  		{

				headers: 
				{
				   'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
	  			url: '/free/vendor/save',
	   			type: 'POST',
	 
			    data: {"sliderfile" : sliderfile,"referralCode" : referralCode,"category" :category,"password" :password,"email" : email,"name": name,"title" :title , "description" : description, "address" :address,"media_id" : media_id},
			    success: function(response)
			    {
					if(response['type'])
					{
						alert(response['type']);
						let url = "/register";
					}
					else
					{
						alert("Account created");
						//let url = "/login/form"
						let url = "/subscribe";
						//let url = "/premium/vendor/preview/"+response['vid']+'/'+response['layouttype'];
						localStorage.removeItem("Title");
						localStorage.removeItem("vendorkey");
						localStorage.removeItem("category");
						localStorage.removeItem("allfiles");
						localStorage.removeItem("Description");
						localStorage.removeItem("addressData");
						localStorage.removeItem("email");
						localStorage.removeItem("name");
						localStorage.removeItem("layout");
						localStorage.removeItem("testimonialData");
						localStorage.removeItem("allEntries");
						localStorage.removeItem("Alldownloadfiles");
						localStorage.removeItem("allportfolioentries");
						localStorage.removeItem("portfoliodata");
						localStorage.removeItem("downloaddata");
						localStorage.removeItem("sliderfiles");
						localStorage.removeItem("password");
						window.location.href = url;
					}
   				}
   			}).done(function() 
   			{
 				setTimeout(function()
 				{
  					$("#overlay").fadeOut(300);
 				},500);
 			});
 		}
		else
		{
			let datastring = '';
			if(title == null )
			{
				datastring += 'Title, '; 
			}
			if(address == null )
			{
				datastring += 'Addrees, '; 
			}
			if(description == null )
			{
				datastring += 'Description, '; 
			}
			if(sliderfile == null)
			{
				datastring += 'at least one media file '; 
			}
			alert(datastring+" required to create an account");
		}
 
 	}

 	
});
$(document).ready(function() 
{
 	$('.js-example-basic-multiple').select2();
 	//$('.js-example-basic-multiple').multiselect();
});

$(document).on("click", ".createprovendor", function()
{
	//alert("Create");
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	let name = localStorage.getItem("name");
	let phoneNumber = localStorage.getItem("Number");
	let Website  = localStorage.getItem("Website");
	let email = localStorage.getItem("email");
	let password = localStorage.getItem("password");
	let content = [];
	let media_id = [];
	media_id = localStorage.getItem("allfiles"); 
	let sliderfile = [];
	sliderfile = localStorage.getItem("sliderfiles"); 
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let referralCode = localStorage.getItem("referralCode");
	let description = localStorage.getItem("Description");
	let category = [];
	category = localStorage.getItem("category");
	//content = testdata;
	let downloaddelete = []; 
	if(name == null || email == null || password ==null)
	{
	 	alert("Name, email and password are required to create an account");
	}
	else
	{
	 	if(title != null && address != null && sliderfile != null)
	 	{
	  		$.ajax(
	  		{

				headers: 
				{
				   'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
	  			url: '/pro-vendor/save',
	   			type: 'POST',
	 
			    data: {"sliderfile" : sliderfile,"referralCode" : referralCode,"category" :category,"password" :password,"email" : email,"name": name,"title" :title , "description" : description, "address" :address,"media_id" : media_id,"phoneNumber":phoneNumber,"Website":Website},
			    success: function(response)
			    {
					if(response['type'])
					{
						alert(response['type']);
						let url = "/vendor/sign-up";
					}
					else
					{
						alert("Account created");
						let url = "/subscribe"
						//let url = "/premium/vendor/preview/"+response['vid']+'/'+response['layouttype'];
						localStorage.removeItem("vendorkey");
						localStorage.removeItem("Title");
						localStorage.removeItem("category");
						localStorage.removeItem("allfiles");
						localStorage.removeItem("Description");
						localStorage.removeItem("addressData");
						localStorage.removeItem("email");
						localStorage.removeItem("name");
						localStorage.removeItem("layout");
						localStorage.removeItem("testimonialData");
						localStorage.removeItem("allEntries");
						localStorage.removeItem("Alldownloadfiles");
						localStorage.removeItem("allportfolioentries");
						localStorage.removeItem("portfoliodata");
						localStorage.removeItem("downloaddata");
						localStorage.removeItem("sliderfiles");
						localStorage.removeItem("password");
						window.location.href = url;
				

					}
   				}
   			}).done(function() 
   			{
 				setTimeout(function()
 				{
  					$("#overlay").fadeOut(300);
 				},500);
 			});
 		}
		else
		{
			let datastring = '';
			if(title == null )
			{
				datastring += 'Title, '; 
			}
			if(address == null )
			{
				datastring += 'Addrees, '; 
			}
			if(description == null )
			{
				datastring += 'Description, '; 
			}
			if(sliderfile == null)
			{
				datastring += 'at least one media file '; 
			}
			alert(datastring+" required to create an account");
		}
 
 	}
});
$(document).on("click", ".newsletter", function()
{
	let id = $(this).data('id');
	//alert(id);
	if ($(this).prop("checked") == true)
	{
		let newsletter = 1;
		$.ajax({
			type: "post",
			data: {
				"_token": $("input[name='_token']").val(),
				"newsletter": newsletter,
				"email": id
			},
			url: '/newsletter',
			success: function(res) {}
		});
		//alert(id);
	}
	else
	{
		let newsletter = 0;
		$.ajax({
			type: "post",
			data: {
				"_token": $("input[name='_token']").val(),
				"newsletter": newsletter,
				"email": id
			},
			url:  '/newsletter',
			success: function(res) {}
		});
	}
	//var checkBox = document.getElementById("invtype");
});

$(document).on('click', '.portfolio', function()
{
	let id = $(this).data('pid');
	let pid = $(this).data('pindex');
	let author = "";
	let Description = "";
	let fileToUpload = [];
	let indexid = '';
	let i = 0;
	let existingportfolioEntries = JSON.parse(localStorage.getItem("allportfolioentries"));
	if (existingportfolioEntries == null)
	{
		existingportfolioEntries = [];
	}
	let temp = [];
	if (existingportfolioEntries.length != 0)
	{
		for (i = 0; i < existingportfolioEntries.length; i++)
		{
			if (existingportfolioEntries[i]['templateTestimonial'] == pid)
			{
				temp = existingportfolioEntries[i];
				existingportfolioEntries.splice(i, 1);
			}
		}
	}
	if (temp.length != '0')
	{
		if (temp['templateTestimonial'] == pid)
		{
			//alert(pid);
			author = temp['Author'];
			Description = temp['Description'];
			fileToUpload = temp['fileToUpload'];
			indexid = temp['templateTestimonial'];
		}
	}
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/vendor/portfolio/display/' + id + '/' + pid,
		type: 'POST',
		data: {
			"_token": $("input[name='_token']").val(),
			"author": author,
			"Description": Description,
			"fileToUpload": fileToUpload,
			'indexid': indexid
		},
		//dataType: 'json',
		success: function(response)
		{
			$('#portfoliomodal').html(response.html);
			$('#portfoliomodal').modal("show");
		}
	}).done(function() 
 		{
 			setTimeout(function() 
 			{
 				$("#overlay").fadeOut(300);
 			}, 500);
 		});
});
$(document).on('click', '.unapprovedPortfolio', function()
{
	let id = $(this).data('pid');
	let unapprovedId = $(this).data('unid');
	let pid = $(this).data('pindex');
	let author = "";
	let Description = "";
	let fileToUpload = [];
	let indexid = '';
	let i = 0;
	let existingportfolioEntries = JSON.parse(localStorage.getItem("allportfolioentries"));
	if (existingportfolioEntries == null)
	{
		existingportfolioEntries = [];
	}
	let temp = [];
	if (existingportfolioEntries.length != 0)
	{
		for (i = 0; i < existingportfolioEntries.length; i++)
		{
			if (existingportfolioEntries[i]['templateTestimonial'] == pid)
			{
				temp = existingportfolioEntries[i];
				existingportfolioEntries.splice(i, 1);
			}
		}
	}
	if (temp.length != '0')
	{
		if (temp['templateTestimonial'] == pid)
		{
			author = temp['Author'];
			Description = temp['Description'];
			fileToUpload = temp['fileToUpload'];
			indexid = temp['templateTestimonial'];
		}
	}
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		headers: {
		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/vendor/unapproved/portfolio/display/' + id + '/' + pid,
		type: 'POST',
		data: {
			"_token": $("input[name='_token']").val(),
			"author": author,
			"Description": Description,
			"fileToUpload": fileToUpload,
			'indexid': indexid,
			'unapprovedId' : unapprovedId
		},
		//dataType: 'json',
		success: function(response)
		{
			$('#portfoliomodal').html(response.html);
			$('#portfoliomodal').modal("show");
		}
	}).done(function() 
 		{
 			setTimeout(function() 
 			{
 				$("#overlay").fadeOut(300);
 			}, 500);
 		});
});
function portfolioDetailsSave(testimonial_id, author, index_id, desc, fileupload, imagepath, existingportfolioEntries)
{
	let test_line = {};
	let test_rows = [];
	test_line.testimonial = testimonial_id;
	test_line.Author = author;
	test_line.templateTestimonial = index_id;
	test_line.Description = desc;
	test_line.fileToUpload = fileupload;
	if(imagepath != null)
	{
		test_line.imagepath = imagepath;
	}
	else
	{
		test_line.imagepath = null;
	}
	test_rows.push(test_line);
	localStorage.setItem("portfoliodata", JSON.stringify(test_rows));
	existingportfolioEntries.push(test_line);
	localStorage.setItem("allportfolioentries", JSON.stringify(existingportfolioEntries));
}
$(document).on('click', '.portfoliosavedata', function() 
{
    localStorage.setItem('vendorkey', true);
    let i = 0;
    let author = $("#author").val();
    let desc = $("#description").val();
    let testimonial_id = $("#portfolioid").val();
    let index_id = $("#indexid").val();
    let filePath = $("#fileUploadPath").val();
    if (document.getElementById('portfoliomodalfile').value == '') 
    {
    	let imagepath = null;
    	if(filePath != undefined)
    	{
    		imagepath = $("#fileUploadPath").val();
    	}
    	let fileupload = null;
        if (testimonial_id == "") 
        {
            let existingportfolioEntries = JSON.parse(localStorage.getItem("allportfolioentries"));
            if (existingportfolioEntries == null) {
                existingportfolioEntries = [];
            }
            let temp = [];
            if (existingportfolioEntries.length != 0) {
                for (i = 0; i < existingportfolioEntries.length; i++) {
                    if (existingportfolioEntries[i]['templateTestimonial'] == index_id) {
                        temp = existingportfolioEntries[i];
                        existingportfolioEntries.splice(i, 1);
                    }
                }
            }
            if (temp.length != "") {
                if (temp['templateTestimonial'] == index_id) {
                    if ($('.pdesc-'.index_id)) {
                        document.getElementById("foliodesc-" + index_id).innerHTML = desc;
                    }
                    if ($('.pauthor-'.index_id)) {
                        document.getElementById("folioauthor-" + index_id).innerHTML = author;
                    }
                }
            } else 
            {
                if ($('.portfolio-'.index_id)) 
                {
                    let content = '<a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="/images/portfolioImg1.svg"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_line pauthor-' + index_id + '" id="folioauthor-' + index_id + '">' + author + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + index_id + '" id="foliodesc-' + index_id + '">' + desc + '</p></div></a>';
                    $('.portfolio-' + index_id).html(content);
                }
            }
        } else {
            if ($('.pdesc-'.testimonial_id)) {
                document.getElementById("foliodesc-" + testimonial_id).innerHTML = desc;
            }
            if ($('.pauthor-'.testimonial_id)) {
                document.getElementById("folioauthor-" + testimonial_id).innerHTML = author;
            }
        }
        let test_rows = [];
        let existingportfolioEntries = JSON.parse(localStorage.getItem("allportfolioentries"));
        if (existingportfolioEntries == null) {
            existingportfolioEntries = [];
        }
        let temp = [];
        if (existingportfolioEntries.length != 0) {
            for (i = 0; i < existingportfolioEntries.length; i++) {
                if (existingportfolioEntries[i]['templateTestimonial'] == index_id) {
                    temp = existingportfolioEntries[i];
                    existingportfolioEntries.splice(i, 1);
                }
            }
        }
        
        if (temp.length !== '0' && temp['templateTestimonial'] == index_id) 
        {
        	portfolioDetailsSave(temp['testimonial'], author, temp['templateTestimonial'], desc, temp['fileToUpload'], temp['imagepath'], existingportfolioEntries);
        }
        else
        {

        	portfolioDetailsSave(testimonial_id, author, index_id, desc, fileupload, imagepath, existingportfolioEntries);
        }
    } 
    else 
    {
        let formData = new FormData();
        var totalfiles = document.getElementById('portfoliomodalfile').files.length;
        for (var index = 0; index < totalfiles; index++) {
            formData.append("fileToUpload[]", document.getElementById('portfoliomodalfile').files[index]);
        }
        formData.append("portfolio_id", $("#portfolioid").val());
        //alert(formData);
        $(document).ajaxSend(function() {
            $("#overlay").fadeIn(300);
        });
        $.ajax({
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/vendorportfoliofiles',
            type: 'POST',
            data: formData,
            contentType: false,
            processData: false,
            dataType: 'json',
            //enctype     : "multipart/form-data",   //it is done inside jquery
            success: function(response) {
                let media = response['media'];
                let records = response['records'];
                let imagepath = response['imagepath'];
                let url = '/' + media.mediaLink;
                let path = media.invention_id;
                let test_rows = [];
                let existingportfolioEntries = JSON.parse(localStorage.getItem("allportfolioentries"));
                if (existingportfolioEntries == null) {
                    existingportfolioEntries = [];
                }
                let temp = [];
                if (existingportfolioEntries.length != 0) 
                {
                    for (i = 0; i < existingportfolioEntries.length; i++) {
                        if (existingportfolioEntries[i]['templateTestimonial'] == index_id) {
                            temp = existingportfolioEntries[i];
                            existingportfolioEntries.splice(i, 1);
                        }
                    }
                }
                if (temp.length != '0' && temp['templateTestimonial'] == index_id) 
                {
                	portfolioDetailsSave(temp['testimonial'], author, temp['templateTestimonial'], desc, records, imagepath, existingportfolioEntries);
                } 
                else 
                {
                	portfolioDetailsSave(testimonial_id, author, index_id, desc, records, imagepath, existingportfolioEntries);
                }
                if (testimonial_id == "") {
                    if ($('#portfolio-'.index_id)) {
                        let content = '<a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="' + url + '"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_line pauthor-' + index_id + '" id="folioauthor-' + index_id + '">' + author + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + index_id + '" id="foliodesc-' + index_id + '">' + desc + '</p></div></a>';
                        $('.portfolio-' + index_id).html(content);
                    }
                } else {
                    if ($('.pdesc-'.testimonial_id)) {
                        document.getElementById("foliodesc-" + testimonial_id).innerHTML = desc;
                    }
                    if ($('.pauthor-'.testimonial_id)) {
                        document.getElementById("folioauthor-" + testimonial_id).innerHTML = author;
                    }
                    if ($('.pimg-'.testimonial_id)) {
                        $("#pimg-" + testimonial_id).attr("src", url);
                    }
                }
            }
        }).done(function() {
            setTimeout(function() {
                $("#overlay").fadeOut(300);
            }, 500);
        });
    }
    $('#portfoliomodal').modal('hide');
});
/*$(document).on("click", ".previewportfolio", function()
{
	//alert("portfolio");
	let id = $(this).data('pid');
	$.ajax(
	{
		url: '/vendor/portfolio/preview/' + id,
		type: 'GET',
		dataType: 'json',
		success: function(response)
		{
			$('#portfoliopreviewmodal').html(response.html);
			$('#portfoliopreviewmodal').modal("show");
		}
	});
});*/

$(document).on("click", ".createpremiumvendor", function()
{
	let name = localStorage.getItem("name");
	let email = localStorage.getItem("email");
	let password = localStorage.getItem("password");
	let layout = localStorage.getItem("layout");
	let content = [];
	let media_id = [];
	media_id = localStorage.getItem("allfiles");
	let sliderfile = [];
	sliderfile = localStorage.getItem("sliderfiles");
	let deletetestimonialtdata = [];
	let testdata = JSON.parse(localStorage.getItem("allEntries"));
	let portfoliodata = JSON.parse(localStorage.getItem("allportfolioentries"));
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let tagline = localStorage.getItem("Tagline");
	let description = localStorage.getItem("Description");
	let category = [];
	category = localStorage.getItem("category");
	content = testdata;
	let downloaddelete = [];
	downloaddelete = JSON.parse(localStorage.getItem("deletedownloadfiles"));
	deletetestimonialtdata = JSON.parse(localStorage.getItem("deletetestimonialEntries"));
	let download = [];
	let referralCode = localStorage.getItem("referralCode");
	download = JSON.parse(localStorage.getItem("Alldownloadfiles"));
	if (name == null || email == null || password == null)
	{
		alert("Name, email and password are required to create an account");
	}
	else
	{
		if (title != null && address != null && description != null && sliderfile != null)
		{
			$(document).ajaxSend(function() 
				{
					$("#overlay").fadeIn(300);　
				});
			$.ajax(
			{
				headers: {
					'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
				url: '/save/premium/vendor',
				/* type: 'POST',
				 data: formData,
				 //data: {"_token": "{{ csrf_token() }}","fileToUpload": fileToUpload, "author": author, "companyname": companyname, "desc": desc, "vendorid": vendorid},
				 dataType: 'json',*/
				type: 'POST',
				data: {
					"_token": $("input[name='_token']").val(),
					"portfoliodata": portfoliodata,
					"layout": layout,
					"sliderfile": sliderfile,
					"category": category,
					"password": password,
					"email": email,
					"name": name,
					"title": title,
					"tagline": tagline,
					"description": description,
					"address": address,
					"media_id": media_id,
					"downloaddelete": downloaddelete,
					"download": download,
					"content": content,
					"deletetestimonialtdata": deletetestimonialtdata,
					"referralCode" : referralCode
				},
				success: function(response)
				{
					if (response['type'])
					{
						alert(response['type']);
						let url = "/vendor/sign-up";
						//window.location.href = url;
					}
					else
					{
						alert("Account created");
						if(response['vid']  == 0)
						{
							let url = '/vendor-list';
							window.location.href = url;
						}
						else
						{
							let url = "/subscribe";
							//let url = "/premium/vendor/preview/" + response['vid'] + '/' + response['layouttype'];
							localStorage.removeItem("vendorkey");
							localStorage.removeItem("Title");
							localStorage.removeItem("category");
							localStorage.removeItem("allfiles");
							localStorage.removeItem("Description");
							localStorage.removeItem("addressData");
							localStorage.removeItem("email");
							localStorage.removeItem("name");
							localStorage.removeItem("layout");
							localStorage.removeItem("testimonialData");
							localStorage.removeItem("allEntries");
							localStorage.removeItem("Alldownloadfiles");
							localStorage.removeItem("allportfolioentries");
							localStorage.removeItem("portfoliodata");
							localStorage.removeItem("downloaddata");
							localStorage.removeItem("sliderfiles");
							localStorage.removeItem("password");
							window.location.href = url;
						}
						
					}
				}
			}).done(function() 
	 		{
	 			setTimeout(function() 
	 			{
	 				$("#overlay").fadeOut(300);
	 			}, 500);
	 		});
		}
		else
		{
			let datastring = '';
			if(title == null )
			{
				datastring += 'Title, '; 
			}
			if(address == null )
			{
				datastring += 'Addrees, '; 
			}
			if(description == null )
			{
				datastring += 'Description, '; 
			}
			if(sliderfile == null)
			{
				datastring += 'at least one media file '; 
			}
			alert(datastring+" required to create an account");
			//alert("Title, category, description and at least one media file are required to create an account");
		}
	}
});
$(document).on("click", ".addVendorPortfolio", function()
{
	let tid = $('#parentportfolio').children().last().attr('data-pindex');
	let indexvalue = parseInt(tid) + 1;
	$('#childportfolio').clone().attr('data-pindex', indexvalue).attr('pid', 0).attr('style', "display:block").attr('id', "portfolio-" + indexvalue).attr('class', "col-md-3 portfolio portfolio-" + indexvalue)
		//.insertAfter($('[id^=childportfolio]:last'))
		.insertAfter(".portfolio-" + tid);;
});
$(document).on("click", ".addVendorTestimonials", function()
{
	let tid = $('#pd').children().last().attr('data-tindex');
	let indexvalue = parseInt(tid) + 1;
	$('#rd').clone()
		// .cd.attr('id', 'gg')
		.attr('data-tindex', indexvalue).attr('testdesc', indexvalue).attr('id', indexvalue).attr('style', "display:block").attr('class', "card box-sha col-12 mb-4 p-3 imgfitshow totaldiv content-item testimonial-block testimonialblock " + indexvalue)
		//.insertAfter($('[id^=rd]:last'))
		.insertAfter("." + tid);;


});

function addfileupload()
{
	let tid = $('#parentfile').children().last().attr('data-tindex');
	alert(tid);
	indexvalue = parseInt(tid) + 1;
	$('#childfile').clone()
		// .cd.attr('id', 'gg')
		.attr('data-tindex', indexvalue).attr('id', indexvalue).attr('class', "col-md-12 " + indexvalue).insertAfter("." + tid);;
}
$(document).on("click", ".closefile", function()
{
	//alert("file close");
	let id = $(this).data('fid');
	//alert(id);
	$(".fileid-" + id).remove();
	$("#downloadid-" + id).remove();
	let test_rows = [];
	let test_line = {};
	let i = 0;
	let existingEntries = JSON.parse(localStorage.getItem("deletedownloadfiles"));
	if (existingEntries == null)
	{
		existingEntries = [];
	}
	let temp = [];
	if (existingEntries.length != 0)
	{
		for (i = 0; i < existingEntries.length; i++)
		{
			if (existingEntries[i]['did'] == id)
			{
				temp = existingEntries[i];
				existingEntries.splice(i, 1);
			}
		}
	}
	if (temp.length != '0')
	{
		if (temp['did'] == id)
		{
			test_line = {};
			test_line.did = id;
			test_rows.push(test_line);
			localStorage.setItem("deletefiledata", JSON.stringify(test_rows));
			existingEntries.push(test_line);
			localStorage.setItem("deletedownloadfiles", JSON.stringify(existingEntries));
		}
		else
		{
			test_line = {};
			test_line.did = id;
			test_rows.push(test_line);
			localStorage.setItem("deletefiledata", JSON.stringify(test_rows));
			existingEntries.push(test_line);
			localStorage.setItem("deletedownloadfiles", JSON.stringify(existingEntries));
		}
	}
	else
	{
		//alert("work");
		test_line = {};
		test_line.did = id;
		test_rows.push(test_line);
		localStorage.setItem("deletefiledata", JSON.stringify(test_rows));
		existingEntries.push(test_line);
		localStorage.setItem("deletedownloadfiles", JSON.stringify(existingEntries));
	}
});
$(document).on("change", "#downloadfile", function()
{
    localStorage.setItem('inventionkey',true);
	let i = 0;
	let fileInput = document.getElementById('downloadfile');
	let filePath = fileInput.value;
	let allowedExtensions = /(\.doc|\.jpg|\.png|\.jpeg|\.zip|\.docx|\.odt|\.pdf|\.tex|\.txt|\.rtf|\.wps|\.wks|\.wpd|\.xls|\.xlsx)$/i;
	if (!allowedExtensions.exec(filePath))
	{
		Swal.fire({
		    title: 'The fileType provided is invalid.',
		    icon: 'error',
		    confirmButtonText: 'OK'
		});
		fileInput.value = '';
		return false;
	}
	let filename = '';
	let formData = new FormData();
	var totalfiles = document.getElementById('downloadfile').files.length;
	//alert(totalfiles);
	//alert(totalfiles);
	var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
	let existingfilesize = localStorage.getItem("inventiondownloadFilesize");
	let filesize = 0;
	if (existingfilesize != null)
	{
		filesize = existingfilesize;
	}
	for (var index = 0; index < totalfiles; index++)
	{
		filesize = parseInt(filesize) + parseInt(document.getElementById('downloadfile').files[index].size);
	}
	if (filesize > MAX_FILE_SIZE)
	{
		alert("All files combined may only occupy 10MB of space or less");
	}
	else
	{
		for (var index = 0; index < totalfiles; index++)
		{
			filename = document.getElementById('downloadfile').files[index].name;
			/*let data = "<div class='row fileid-"+ index+"'><div class='col-md-8'>"+filename+"</div><div class='col-md-4'><button type='button' data-fid='"+index+"' class='close  closefile index' aria-label='Close'><span class='' aria-hidden='true'>&times;</span></button></div></div><br>"                                   
			$('.filenames').append(data);*/
			formData.append("fileToUpload[]", document.getElementById('downloadfile').files[index]);
		}
	}
	localStorage.setItem("inventiondownloadFilesize", filesize);
	formData.append('inventionid', $('#invid').val());
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/inventiondownloadfile',
		type: 'POST',
		data: formData,
		contentType: false,
		processData: false,
		dataType: 'json',
		//enctype     : "multipart/form-data",   //it is done inside jquery
		success: function(response)
		{
			let media = response['filedata'];
			let filename = response['fdata'];
			let data = "";
			//let data ="<div class='row d-flex bd-highlight card-box'>";
			for (i = 0; i < filename.length; i++)
			{
				let url = '/invention/donwload-file/' + filename[i].id;
					data += '<a href="javascript:void(0)" class="p4">'+filename[i].fileName+'<img class="ms-2" href="{{ asset("images/arrow-download.svg") }}" alt=""></a><hr class="w-75 text-secondry">'; 

				//data += "<div class='col-md-3 fileid-" + filename[i].id + " p-2 flex-fill bd-highlight'><a href=" + url + " target='_blank'><div class='img'><img class='downloadimg' src='{{url('images/filedownload.png')}}' height='100px' width='100px;'/><br>" + filename[i].fileName + "</div></a><div class='remo'><button type='button' data-fid='" + filename[i].id + "' class='closefile index btn btn-xs btn-danger'><i class='fa fa-trash-o'></i></button></div></div>";
				//let data = "<div class='row fileid-"+ filename[i].id+"'><div class='col-md-8'><a href=''><img class='downloadimg' src='{{url('images/filedownload.png')}}' height='50px' width='50px;'/> &nbsp;&nbsp;"+filename[i].fileName+"</a></div><div class='col-md-4'><button type='button' data-fid='"+filename[i].id+"' class='close  closefile index' aria-label='Close'><span class='' aria-hidden='true'>&times;</span></button></div></div><br>"                                   
			}
			//data += "</div>";
			$('.filenames').append(data);
			$('.demofile').css("display", "none");
			let existingdeleteEntries = JSON.parse(localStorage.getItem("Alldownloadfiles"));
			if (existingdeleteEntries == null)
			{
				existingdeleteEntries = [];
			}
			let test_rows = [];
			for (i = 0; i < media.length; i++)
			{
				//alert("yes");
				let test_line = {};
				test_line.did = media[i];
				test_rows.push(test_line);
				localStorage.setItem("downloaddata", JSON.stringify(test_rows));
				existingdeleteEntries.push(test_line);
				localStorage.setItem("Alldownloadfiles", JSON.stringify(existingdeleteEntries));
			}
			
		}
	}).done(function() 
 		{
 			setTimeout(function() 
 			{
 				$("#overlay").fadeOut(300);
 			}, 500);
 		});
});

$(document).on("change", "#vendordownloadfile", function()
{
    localStorage.setItem('vendorkey',true);
	let fileInput = document.getElementById('vendordownloadfile');
	let filePath = fileInput.value;
	let allowedExtensions = /(\.doc|\.jpg|\.png|\.jpeg|\.zip|\.docx|\.odt|\.pdf|\.tex|\.txt|\.rtf|\.wps|\.wks|\.wpd|\.xls|\.xlsx)$/i;
	if (!allowedExtensions.exec(filePath))
	{
		Swal.fire({
		    title: 'The fileType provided is invalid.',
		    icon: 'error',
		    confirmButtonText: 'OK'
		});
		fileInput.value = '';
		return false;
	}
	let filename = '';
	let formData = new FormData();
	let totalfiles = document.getElementById('vendordownloadfile').files.length;
	//alert(totalfiles);
	let MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
	let existingfilesize = localStorage.getItem("downloadFilesize");
	let filesize = 0;
	if (existingfilesize != null)
	{
		filesize = existingfilesize;
	}
	for (var index = 0; index < totalfiles; index++)
	{
		filesize = parseInt(filesize) + parseInt(document.getElementById('vendordownloadfile').files[index].size);
	}
	if (filesize > MAX_FILE_SIZE)
	{
		alert("All files combined may only occupy 10MB of space or less");
	}
	else
	{
		for (var index = 0; index < totalfiles; index++)
		{
			filename = document.getElementById('vendordownloadfile').files[index].name;
			formData.append("fileToUpload[]", document.getElementById('vendordownloadfile').files[index]);
		}
		localStorage.setItem("downloadFilesize", filesize);
		formData.append('inventionid', $('#invid').val());
		$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
			headers: {
				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
			},
			url: '/vendordownloadfile',
			type: 'POST',
			data: formData,
			contentType: false,
			processData: false,
			dataType: 'json',
			//enctype     : "multipart/form-data",   //it is done inside jquery
			success: function(response)
			{
				let media = response['filedata'];
				let filename = response['fdata'];
				let data = "";
				//let data ="<div class='row d-flex bd-highlight card-box'>";
				for (i = 0; i < filename.length; i++)
				{
					let url = '/invention/donwload-file/' + filename[i].id;
					data += '<div class="row fileid-'+filename[i].id+'"><div class="col-md-8"><a href="javascript:void(0)" class="p4 fileid-'+filename[i].id+'">'+filename[i].fileName+'<img class="ms-2 " href="{{ asset("images/arrow-download.svg") }}" alt=""></a></div><div class="col-md-4"><button type="button" data-fid="'+filename[i].id+'" class="close fileid-'+filename[i].id+' closefile index" aria-label="Close"><span class="" aria-hidden="true">&times;</span></button></div><hr class="w-75 fileid-'+filename[i].id+' text-secondry"></div>'; 
					//let data = "<div class='row fileid-"+ filename[i].id+"'><div class='col-md-8'><a href=''><img class='downloadimg' src='{{url('images/filedownload.png')}}' height='50px' width='50px;'/> &nbsp;&nbsp;"+filename[i].fileName+"</a></div><div class='col-md-4'><button type='button' data-fid='"+filename[i].id+"' class='close  closefile index' aria-label='Close'><span class='' aria-hidden='true'>&times;</span></button></div></div><br>"                                   
				}
				//data += "</div>";
				$('.filenames').append(data);
				let existingdeleteEntries = JSON.parse(localStorage.getItem("Alldownloadfiles"));
				if (existingdeleteEntries == null)
				{
					existingdeleteEntries = [];
				}
				let test_rows = [];
				let i = 0;
				for (i = 0; i < media.length; i++)
				{
					//alert("yes");
					let test_line = {};
					test_line.did = media[i];
					test_rows.push(test_line);
					localStorage.setItem("downloaddata", JSON.stringify(test_rows));
					existingdeleteEntries.push(test_line);
					localStorage.setItem("Alldownloadfiles", JSON.stringify(existingdeleteEntries));
				}
			}
		}).done(function() 
 		{
 			setTimeout(function() 
 			{
 				$("#overlay").fadeOut(300);
 			}, 500);
 		});
	}
});
$(document).on("click", ".aboutInventor", function()
{
	let tid = $('#inventorparentrow').children().last().attr('data-tindex');
	let indexvalue = parseInt(tid) + 1;
	$('#inventorchildrow').clone()
		// .cd.attr('id', 'gg')
		.attr('data-tindex', indexvalue).attr('testdesc', indexvalue).attr('style', "display:block").attr('id', indexvalue).attr('style', "display:block").attr('class', "card box-sha col-12 mb-4 p-3 imgfitshow totaldiv inventor-block content-item inventioninventorblock inventor-" + indexvalue)
		//.insertAfter($('[id^=rd]:last'))
		.insertAfter(".inventor-" + tid);;
	
});

$(document).on("click", ".addTestimonials", function()
{
	let tid = $('#pd').children().last().attr('data-tindex');
	let indexvalue = parseInt(tid) + 1;
	$('#rd').clone().attr('data-tindex', indexvalue).attr('testdesc', indexvalue).attr('id', indexvalue).attr('style', "display:block").attr('class', "col-md-4 col-sm-6 col-lg-3 mb-4 testimonial-block content-item inventontestimonialblock " + indexvalue).insertAfter("." + tid);;
	
});

$(document).on("click", ".testimonialblock", function()
{
	let id = $(this).data('tid');
	let tid = $(this).data('tindex');
	let author = "";
	let Description = "";
	let fileToUpload = [];
	let indexid = "";
	let companyName = "";
	let i = 0;
	let vendorrowdata = JSON.parse(localStorage.getItem("allEntries"));
	if (vendorrowdata == null)
	{
		vendorrowdata = [];
	}
	let temp = [];
	if (vendorrowdata.length != 0)
	{
		for (i = 0; i < vendorrowdata.length; i++)
		{
			if (vendorrowdata[i]['templateTestimonial'] == tid)
			{
				temp = vendorrowdata[i];
				vendorrowdata.splice(i, 1);
			}
		}
	}
	if (temp.length != '0')
	{
		if (temp['templateTestimonial'] == tid)
		{
			author = temp['Author'];
			Description = temp['Description'];
			fileToUpload = temp['fileToUpload'];
			indexid = temp['templateTestimonial'];
			companyName = temp['companyName'];
		}
	}
	$(document).ajaxSend(function() 
		{
			$("#overlay").fadeIn(300);　
		});

	$.ajax(
	{
		headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/vendortestimonialsave/' + id + '/' + tid,
		type: 'POST',
		data: {
			"_token": $("input[name='_token']").val(),
			"author": author,
			"Description": Description,
			"fileToUpload": fileToUpload,
			"indexid": indexid,
			"companyName": companyName
		},
		success: function(response)
		{
			$('#testimonialModal').html(response.html);
			$('#testimonialModal').modal("show");
		}
	}).done(function() 
 		{
 			setTimeout(function() 
 			{
 				$("#overlay").fadeOut(300);
 			}, 500);
 		});
});

$(document).on("click", ".vendorupdatetestimonial", function()
	{
    	localStorage.setItem('vendorkey',true);
		$("#overlay").fadeIn(300);
		let author = $("#modalauthor").val();
		let companyname = $("#modalcompanyname").val();
		let desc = $("#modaldesc").val();
		let testimonial_id = $("#testid").val();
		let index_id = $("#tindexid").val();
		let i = 0;
		let test_line = null;
		let filePath = $("#fileUploadPath").val();
		if (document.getElementById('modalfile').value == '')
		{
			if (testimonial_id == "")
			{
				let existingvendordata = JSON.parse(localStorage.getItem("allEntries"));
				if (existingvendordata == null)
				{
					existingvendordata = [];
				}
				let temp = [];
				if (existingvendordata.length != 0)
				{
					for (i = 0; i < existingvendordata.length; i++)
					{
						if (existingvendordata[i]['templateTestimonial'] == index_id)
						{
							temp = existingvendordata[i];
							existingvendordata.splice(i, 1);
						}
					}
				}
				if (temp.length != '0')
				{
					if (temp['templateTestimonial'] == index_id)
					{
						if ($('.desc-'.index_id))
						{
							document.getElementById("testdesc-" + index_id).innerHTML = desc;
						}
						if ($('.author-'.index_id))
						{
							document.getElementById("testauthor-" + index_id).innerHTML = author;
						}
						if ($('.company-'.index_id))
						{
							document.getElementById("testcomapny-" + index_id).innerHTML = companyname;
						}
					}
				}
				else
				{
					if ($('#'.index_id))
					{
						let url =  '/images/avtar.JPG';
						let content = '<div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' + url + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + author + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">' + companyname + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + desc + '</h5></div></div></div>';
						$('.' + index_id).html(content);
					}
				}
			}
			let test_rows = [];
			let existingEntries = JSON.parse(localStorage.getItem("allEntries"));
			if (existingEntries == null)
			{
				existingEntries = [];
			}
			let temp = [];
			if (existingEntries.length != 0)
			{
				for (i = 0; i < existingEntries.length; i++)
				{
					if (existingEntries[i]['templateTestimonial'] == index_id)
					{
						temp = existingEntries[i];
						existingEntries.splice(i, 1);
					}
				}
			}
			if (temp.length != '0')
			{
				if (temp['templateTestimonial'] == index_id)
				{
					test_line = {};
					test_line.testimonial = temp['testimonial'];
					test_line.Author = author;
					test_line.templateTestimonial = temp['templateTestimonial'];
					testimonial_id
					test_line.companyName = companyname;
					test_line.Description = desc;
					test_line.fileToUpload = temp['fileToUpload'];
					test_rows.push(test_line);
					localStorage.setItem("testimonialData", JSON.stringify(test_rows));
					existingEntries.push(test_line);
					localStorage.setItem("allEntries", JSON.stringify(existingEntries));
				}
				else
				{
					test_line = {};
					test_line.testimonial = testimonial_id;
					test_line.Author = author;
					test_line.templateTestimonial = index_id;
					test_line.companyName = companyname;
					test_line.Description = desc;
					test_line.fileToUpload = null;
					test_rows.push(test_line);
					localStorage.setItem("testimonialData", JSON.stringify(test_rows));
					existingEntries.push(test_line);
					localStorage.setItem("allEntries", JSON.stringify(existingEntries));
				}
			}
			else
			{
				test_line = {};
				test_line.testimonial = testimonial_id;
				test_line.Author = author;
				test_line.templateTestimonial = index_id;
				test_line.companyName = companyname;
				test_line.Description = desc;
				if(filePath != undefined)
				{
					test_line.fileToUpload = filePath;
				}
				else
				{
					test_line.fileToUpload = null;
				}
				
				test_rows.push(test_line);
				localStorage.setItem("testimonialData", JSON.stringify(test_rows));
				existingEntries.push(test_line);
				localStorage.setItem("allEntries", JSON.stringify(existingEntries));
			}
		}
		else
		{
			let formData = new FormData();
			var totalfiles = document.getElementById('modalfile').files.length;
			for (var index = 0; index < totalfiles; index++)
			{
				formData.append("fileToUpload[]", document.getElementById('modalfile').files[index]);
			}
			formData.append("testimonial_id", $("#testid").val());
			//alert(formData);
			$.ajax(
			{
				headers: {
					'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
				},
				url:  '/vendortestimonialfiles',
				type: 'POST',
				data: formData,
				contentType: false,
				processData: false,
				dataType: 'json',
				//enctype     : "multipart/form-data",   //it is done inside jquery
				success: function(response)
				{
					let media = response['media'];
					let url =  '/' + media.mediaLink;
					let path = media.invention_id;
					let test_rows = [];
					let existingEntries = JSON.parse(localStorage.getItem("allEntries"));
					if (existingEntries == null)
					{
						existingEntries = [];
					}
					let temp = [];
					if (existingEntries.length != 0)
					{
						for (i = 0; i < existingEntries.length; i++)
						{
							if (existingEntries[i]['templateTestimonial'] == index_id)
							{
								temp = existingEntries[i];
								existingEntries.splice(i, 1);
							}
						}
					}
					if (temp.length != '0')
					{
						if (temp['templateTestimonial'] == index_id)
						{
							test_line = {};
							test_line.testimonial = temp['testimonial'];
							test_line.Author = author;
							test_line.templateTestimonial = temp['templateTestimonial'];
							testimonial_id
							test_line.companyName = companyname;
							test_line.Description = desc;
							test_line.fileToUpload = media.mediaLink;
							test_rows.push(test_line);
							localStorage.setItem("testimonialData", JSON.stringify(test_rows));
							existingEntries.push(test_line);
							localStorage.setItem("allEntries", JSON.stringify(existingEntries));
						}
						else
						{
							test_line = {};
							test_line.testimonial = testimonial_id;
							test_line.Author = author;
							test_line.templateTestimonial = index_id;
							test_line.companyName = companyname;
							test_line.Description = desc;
							test_line.fileToUpload = media.mediaLink;
							test_rows.push(test_line);
							test_rows.push(test_line);
							localStorage.setItem("testimonialData", JSON.stringify(test_rows));
							existingEntries.push(test_line);
							localStorage.setItem("allEntries", JSON.stringify(existingEntries));
						}
					}
					else
					{
						test_line = {};
						test_line.testimonial = testimonial_id;
						test_line.Author = author;
						test_line.templateTestimonial = index_id;
						test_line.companyName = companyname;
						test_line.Description = desc;
						test_line.fileToUpload = media.mediaLink;
						test_rows.push(test_line);
						localStorage.setItem("testimonialData", JSON.stringify(test_rows));
						existingEntries.push(test_line);
						localStorage.setItem("allEntries", JSON.stringify(existingEntries));
					}
					if (testimonial_id == "")
					{
						if ($('#'.index_id))
						{
							let content = '<div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' + url + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + author + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">' + companyname + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + desc + '</h5></div></div></div>';
							/*let content = '<div class="quote dark"><blockquote><p class="" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-' + index_id + '">' + desc + '</p></blockquote></div>'
							content += '<div class="quote-footer text-right"><div class="quote-author-img img"><img src="' + url + '" class="img" id="img-' + index_id + '"  alt=""></div><h4 class="cjs-allow-change  author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-' + index_id + '">' + author + '</h4><p><strong class="cjs-allow-change  company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-' + index_id + '">' + companyname + '</strong></p></div>'
							*/$('.' + index_id).html(content);
						}
					}
					else
					{
						if ($('.desc-'.testimonial_id))
						{
							document.getElementById("testdesc-" + testimonial_id).innerHTML = desc;
						}
						if ($('.author-'.testimonial_id))
						{
							document.getElementById("testauthor-" + testimonial_id).innerHTML = author;
						}
						if ($('.company-'.testimonial_id))
						{
							document.getElementById("testcomapny-" + testimonial_id).innerHTML = companyname;
						}
						if ($('.img-'.testimonial_id))
						{
							$("#img-" + testimonial_id).attr("src", url);
						}
					}
				}
			});
		}
		$('#testimonialModal').modal('hide');
		$("#overlay").fadeOut(300);
	});
$(document).on("change click", ".imageupload", function()
 {
    localStorage.setItem('inventionkey',true);
 	let i= 0;
	 	var vfileName = $(".imageupload").val();
	 	if(vfileName == '')
	 	{
		   	$("#overlay").fadeIn(300);
		   	let formData = new FormData();
		   	let media_id = [];
		   	media_id = localStorage.getItem("allfiles"); 
		   	var totalfiles = document.getElementById('modalfile').files.length;
		   	for (var index = 0; index < totalfiles; index++) 
		   	{
		   	 	formData.append("fileToUpload[]", document.getElementById('modalfile').files[index]);
		   	}
		   	formData.append("videoLink", $("#mediaLink").val());
		   	formData.append("invid", $("#invid").val());
		   	formData.append("media_id", media_id);
		   	$('.loader').css("display", "block");
		   	$.ajax(
		   	{
		   	 	beforeSend:function () 
		   	 	{
		   	 		let invid = $(this).data('invid');
		   	 		$('.loader').css("display", "block");
		   	 	},
		   	 	headers: {
		   	 		'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		   	 	},
		   	 	url:   '/inventionfiles' ,
		   	 	type: 'POST',
		   	 
		   	 	data: formData,
		   	 	contentType: false,
		   	 	processData: false,
		   	 	success: function(response)
		   	 	{
			   	 	if(response.linkStatus == true)
			   	 	{
			   	 		alert("Invalid youtube link, kindly use your youtube video link from browser addressbar");
			   	 		$("#mediaLink").val('');

			   	 	}
			   	 	else
			   	 	{
			   	 		let file_row = [];
			   	 		let existfiles = JSON.parse(localStorage.getItem("allfiles"));
			   	 		if (existfiles == null) {
			   	 			existfiles = [];
			   	 		}

			   	 		let media_id = [];
			   	 		let media = response.media;
			   	 		let existmedias = response.existmedias;
			   	 		let record = "<table>"
			   	 		if (existmedias.length != 0) {
			   	 			for (i = 0; i < existmedias.length; i++) {
			   	 				if (existmedias[i].fileType == '1') {
			   	 					record += "<tr class='" + existmedias[i].inventionmedia_id + "'><td><iframe src='" + existmedias[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td> </td><td><button class='btn btn-danger removesliderimage' data-fid='" + existmedias[i].inventionmedia_id + "'><i class='fa fa-trash-o'></i></button></td><tr><tr></tr>";

			   	 				} else {
			   	 					record += '<tr class="' + existmedias[i].inventionmedia_id + '"><td><img src="' + '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td> </td><td><button class="btn btn-danger removesliderimage" data-fid="' + existmedias[i].inventionmedia_id + '"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
			   	 				}
			   	 			}
			   	 		}
			   	 		for (i = 0; i < media.length; i++) {
			   	 			if (media[i].fileType == '1') {
			   	 				record += "<tr class='" + media[i].inventionmedia_id + "'><td><iframe src='" + media[i].mediaLink + ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td> </td><td><button class='btn btn-danger removesliderimage' data-fid='" + media[i].inventionmedia_id + "'><i class='fa fa-trash-o'></i></button></td><tr><tr></tr>";

			   	 			} else {
			   	 				record += '<tr class="' + media[i].inventionmedia_id + '"><td><img src="' + '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td> </td><td><button class="btn btn-danger removesliderimage" data-fid="' + media[i].inventionmedia_id + '"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
			   	 			}
			   	 			existfiles.push(media[i].inventionmedia_id);
			   	 			localStorage.setItem("allfiles", JSON.stringify(existfiles));
			   	 			$("#overlay").fadeOut(300);
			   	 		}
			   	 		$('#newdata').html(record);
			   	 		$('.sliderarea').html(response.html);
			   	 		var nsOptions = {
			   	 			sliderId: "ninja-slider",
			   	 			transitionType: "fade",
			   	 			autoAdvance: true,
			   	 			rewind: true,
			   	 			delay: 10000,
			   	 			transitionSpeed: 5000,
			   	 			aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
			   	 			initSliderByCallingInitFunc: false,
			   	 			shuffle: false,
			   	 			startSlideIndex: 0, //0-based
			   	 			navigateByTap: false,
			   	 			pauseOnHover: false,
			   	 			keyboardNav: true,
			   	 			before: null,
			   	 			license: ninjaSliderKey
			   	 		};
			   	 		var nslider = new NinjaSlider(nsOptions); //function call
	 				    function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
			   	 		$('#modalfile').val("");
			   	 		$('#mediaLink').val("");
			   	 		$('.loader').css("display", "none");
			   	 	}	
		   	 
		   	 	}
		   	});	
	 	}
	 	else
	 	{
					var idxDot = vfileName.lastIndexOf(".") + 1;
	 				var extFile = vfileName.substr(idxDot, vfileName.length).toLowerCase();
	 				if (extFile=="jpg" || extFile=="jpeg" || extFile=="png")
	 				{
	 				    //TO DO
	 				     	$("#overlay").fadeIn(300);
	 				     //alert(document.getElementById('modalfile').value);
	 				     let formData = new FormData();
	 				     let media_id = [];
	 				     //deletetestimonialtdata = JSON.parse(localStorage.getItem("deletetestimonialEntries"));
	 				     
	 				     media_id = localStorage.getItem("allfiles"); 
	 				     // let existingMedia = JSON.parse(localStorage.getItem("allmedia"));
	 				     var totalfiles = document.getElementById('modalfile').files.length;
	 				     for (var index = 0; index < totalfiles; index++) 
	 				     {
	 				     formData.append("fileToUpload[]", document.getElementById('modalfile').files[index]);
	 				     }
	 				     formData.append("videoLink", $("#mediaLink").val());
	 				     formData.append("invid", $("#invid").val());
	 				     formData.append("media_id", media_id);
	 				     $('.loader').css("display", "block");
	 				     $.ajax(
	 				     {
	 				     	 beforeSend:function () 
	 				     	 {
	 				     		//alert("working");
	 				     			let invid = $(this).data('invid');
	 				     	
	 				     		 // $('.loader').show();
	 				     		  //.css("display", "block");
	 				     		   $('.loader').css("display", "block");
	 				     	  },
	 				     headers: {
	 				     'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
	 				     },
	 				     url:  '/inventionfiles' ,
	 				     type: 'POST',
	 				     
	 				     data: formData,
	 				     contentType: false,
	 				     processData: false,
	 				     //dataType: 'json',
	 				     //enctype     : "multipart/form-data",   //it is done inside jquery
	 				     success: function(response)
	 				     {
	 				     let file_row = [];
	 				     //existfiles = [];
	 				     
	 				     //alert(response.medias);
	 				      let existfiles = JSON.parse(localStorage.getItem("allfiles"));
	 				      if(existfiles == null)
	 				      {
	 				       existfiles = [];
	 				      } 
	 				     
	 				     let media_id = [];
	 				     let media = response.media;
	 				     let existmedias = response.existmedias;
	 				     let record = "<table>"
	 				     if(existmedias.length != 0)
	 				     {
	 				      for (i = 0; i < existmedias.length; i++) 
	 				      {
	 				       if(existmedias[i].fileType == '1')
	 				       {
	 				    	  record += "<tr class='"+existmedias[i].inventionmedia_id+"'><td><iframe src='" +existmedias[i].mediaLink+ ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removesliderimage' data-fid='"+existmedias[i].inventionmedia_id+"'><i class='fa fa-trash-o'></i></button></td><tr><tr></tr>";
	 				     
	 				       }
	 				       else
	 				       {
	 				    	  record += '<tr class="'+existmedias[i].inventionmedia_id+'"><td><img src="'   + '/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removesliderimage" data-fid="'+existmedias[i].inventionmedia_id+'"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
	 				       }
	 				      }
	 				     }
	 				     for (i = 0; i < media.length; i++) 
	 				     {
	 				      if(media[i].fileType == '1')
	 				      {
	 				       record += "<tr class='"+media[i].inventionmedia_id+"'><td><iframe src='" +media[i].mediaLink+ ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removesliderimage' data-fid='"+media[i].inventionmedia_id+"'><i class='fa fa-trash-o'></i></button></td><tr><tr></tr>";
	 				     
	 				      }
	 				      else
	 				      {
	 				       record += '<tr class="'+media[i].inventionmedia_id+'"><td><img src="'   + '/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removesliderimage" data-fid="'+media[i].inventionmedia_id+'"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
	 				      }
	 				      //media_id += media[i].inventionmedia_id;
	 				      /*test_line = {};
	 				      test_line.testimonial = media[i].inventionmedia_id;
	 				      file_row.push(test_line);
	 				      localStorage.setItem("uploadededfile",JSON.stringify(file_row));*/
	 				      existfiles.push(media[i].inventionmedia_id);
	 				      localStorage.setItem("allfiles", JSON.stringify(existfiles));
	 				      $("#overlay").fadeOut(300);
	 				     }
	 				     $('#newdata').html(record);
	 				       
	 				     $('.sliderarea').html(response.html);
	 				     	var nsOptions =
	 				       	{
	 				     	  sliderId: "ninja-slider",
	 				     	  transitionType: "fade",
	 				     	  autoAdvance: true,
	 				     	  rewind: true,
	 				     	  delay: 10000,
	 				     	  transitionSpeed: 5000,
	 				     	  aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
	 				     	  initSliderByCallingInitFunc: false,
	 				     	  shuffle: false,
	 				     	  startSlideIndex: 0, //0-based
	 				     	  navigateByTap: false,
	 				     	  pauseOnHover: false,
	 				     	  keyboardNav: true,
	 				     	  before: null,
	 				     	  license: ninjaSliderKey
	 				       };
	 				       var nslider = new NinjaSlider(nsOptions);//function call
	 				       function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
	 				     
	 				     $('#modalfile').val("");
	 				     $('#mediaLink').val("");
	 				     $('.loader').css("display", "none");
	 				     }
	 				     });
	 				}
	 				else
	 				{
	 				    alert("Only jpg/jpeg and png files are allowed!");
	 				    $(".imageupload").val('');
	 				    $(".imageuploadvalidation").val('');
	 				}
	 	}
	       
	 	   
 	
 });

$(document).on("click", ".provendor-hidedata", function()
{
	let vendorId = $(this).data('id');
	let address = JSON.parse(localStorage.getItem("addressData"));
	let title = localStorage.getItem("Title");
	let phoneNumber = localStorage.getItem("Number");
	let website = localStorage.getItem("Website");
	let description = localStorage.getItem("Description");
	let sliderfile = [];
	sliderfile = localStorage.getItem("sliderfiles");
	datacollect(address, title, description, sliderfile, website, phoneNumber, vendorId);
});
$(document).on("click", ".vendorfree-hidedata", function()
{
	let vendorId = $(this).data('id');
 	let address = JSON.parse(localStorage.getItem("addressData"));
 	let title = localStorage.getItem("Title");
 	let description = localStorage.getItem("Description");
 	let sliderfile = [];
 	sliderfile = localStorage.getItem("sliderfiles"); 
 	datafreecollect(address,title,description,sliderfile,vendorId);
});
function datafreecollect(address,title,description,sliderfile,vendorId)
{
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
 	$.ajax(
	{
		headers: 
		{
				   'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
	  	url: '/free/vendor/preview',
	   	type: 'POST',
	   	data: {
	   		"sliderfile" : sliderfile,
	   		"title" : title,
	   		"description" : description,
	   		"address" : address,
	   		"vendorId" : vendorId
	   	},
		success: function(response)
		{
 			$('#freeSignUp').html(response.html);
 			  var nsOptions =
 			  {
 				  sliderId: "ninja-slider",
 				  transitionType: "fade",
 				  autoAdvance: true,
 				  rewind: true,
 				  delay: 10000,
 				  transitionSpeed: 5000,
 				  aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
 				  initSliderByCallingInitFunc: false,
 				  shuffle: false,
 				  startSlideIndex: 0, //0-based
 				  navigateByTap: false,
 				  pauseOnHover: false,
 				  keyboardNav: true,
 				  before: null,
 				  license: ninjaSliderKey
 			  };
 			var nslider = new NinjaSlider(nsOptions);//function call
 			function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
 			$('#freeSignUp').modal("show");
		}
	}).done(function() 
 	{
 		setTimeout(function() 
 		{
 			$("#overlay").fadeOut(300);
 		}, 500);
 	});	
}
function datacollect(address, title, description, sliderfile, website, phoneNumber, vendorId)
{
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});
	$.ajax(
	{
		headers:
		{
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url: '/pro/vendor/preview',
		type: 'POST',
		data: {
			"website" : website,
			"phoneNumber" : phoneNumber,
			"sliderfile" : sliderfile,
			"title" : title,
			"description" : description,
			"address" : address,
			"vendorId" : vendorId
		},
		success: function(response)
		{
			$('#ProSignUp').html(response.html);
			  var nsOptions =
			  {
				  sliderId: "ninja-slider2",
				  transitionType: "fade",
				  autoAdvance: true,
				  rewind: true,
				  delay: 10000,
				  transitionSpeed: 5000,
				  aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
				  initSliderByCallingInitFunc: false,
				  shuffle: false,
				  startSlideIndex: 0, //0-based
				  navigateByTap: false,
				  pauseOnHover: false,
				  keyboardNav: true,
				  before: null,
				  license: ninjaSliderKey
			  };
			var nslider = new NinjaSlider(nsOptions);//function call
			function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
			
			$('#ProSignUp').modal("show");
		}
	}).done(function() 
 	{
 		setTimeout(function() 
 		{
 			$("#overlay").fadeOut(300);
 		}, 500);
 	});
}



$(document).on("click", ".imageuploadfiledata", function()
{
	$(".imageblock").css("display", "block");
	$("#video").css("display", "none");
});


 $(document).on("click", ".introjs-skipbutton", function(event)
 {
 	let myVar = setTimeout(newsFunc, 100);
 	let usertype = $("#login_id").val();
 	if(usertype != 0)
 	{
 		$(document).ajaxSend(function() 
 		{
 			$("#overlay").fadeIn(300);　
 		});
 		$.ajax(
 		{
 			headers: {
 				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
 			},
 			url:  '/user/tour/save',
 			type: 'POST',
 			data: 	{
 						'usertype' :usertype,
 						"_token": $("input[name='_token']").val(),
 						"type" : "yes"
  					},
 			success: function(response)
 			{
 			},
 			error: function(jqXHR, textStatus, errorThrown, response)
 			{
 				alert('Internal error: ' + errorThrown);
 			}
 		}).done(function() 
 		{
 			setTimeout(function() 
 			{
 				$("#overlay").fadeOut(300);
 			}, 500);
 		});
 	}
 	else
 	{
 		sessionStorage.setItem("UserTourFlag",true);
 	}
	
 });
 $(document).ready(function()
 {
 	let user = $("#login_id").val();
 	if(user == 0 )
 	{
 		let myVar = setTimeout(newsFunc, 5000);
 		
 	}
 	/*else
 	{	
 		if(usertour != 'yes')
 		{
 			javascript:introJs().start();
 		}
 	}
 	let myVar = setTimeout(newsFunc, 5000);*/
 	//let myVar = setTimeout(newsFunc, 10000);
 });
 function newsFunc()
 {
 	if (localStorage.getItem("newsletterSubscriptionModal"))
 	{
 		//$('#newsModal').modal("show");
 	}
 	else
 	{
 		$('#newsModal').modal("show");
 	}
 }

/*$(document).on("click", ".introjs-donebutton", function(event)
{
 	let myVar = setTimeout(newsFunc, 100);
});*/
let newsletterSubscriptionModal = 'false';


$(document).on("click", ".newsbutton", function(event)
{
	let email = $("#email").val();
	if (email == '')
	{
		alert("Please Enter Email");
	}
	else
	{
		//alert(email);
		$.ajax({
			url:  '/savenews',
			method: "POST",
			data: {
				"_token": $("input[name='_token']").val(),
				"email": email
			},
			success: function(data)
			{
				$('#newsmessage').html(data);
				$('.popuptitle').text('');
			}
		});
	}
});

$(document).on("click", ".newslocalstore", function(event)
{
	localStorage.setItem("newsletterSubscriptionModal", true);
	$('#newsModal').modal("hide");
});

$(document).on("click", ".invtype", function(event)
{
	let id = $(this).data('id');
	if ($(this).prop("checked") == true)
	{
		let anonymous = 1;
		$.ajax({
			type: "post",
			data: {
				"_token": $("input[name='_token']").val(),
				"anonymous": anonymous
			},
			url:  '/anonymous/' + id,
			success: function(res) {}
		});
		//alert(id);
	}
	else
	{
		let anonymous = 0;
		$.ajax({
			type: "post",
			data: {
				"_token": $("input[name='_token']").val(),
				"anonymous": anonymous
			},
			url:  '/anonymous/' + id,
			success: function(res) {}
		});
	}
	//var checkBox = document.getElementById("invtype");
});
$(document).on("click", ".tourtype", function(event)
{
	let id = $(this).data('id');
	if ($(this).prop("checked") == true)
	{
		let type = 'yes';
		$.ajax({
			type: "post",
			data: {
				"_token": $("input[name='_token']").val(),
				"type": type
			},
			url:  '/user/tour/save' ,
			success: function(res) {}
		});
		//alert(id);
	}
	else
	{
		let type = 'no';
		$.ajax({
			type: "post",
			data: {
				"_token": $("input[name='_token']").val(),
				"type": type
			},
			url:  '/user/tour/save' ,
			success: function(res) {}
		});
	}
	//var checkBox = document.getElementById("invtype");
});

$(document).on("click", ".newsletter", function(event)
	{
		let id = $(this).data('id');
		//alert(id);
		if ($(this).prop("checked") == true)
		{
			let newsletter = 1;
			$.ajax({
				type: "post",
				data: {
					"_token": $("input[name='_token']").val(),
					"newsletter": newsletter,
					"email": id
				},
				url:  '/newsletter',
				success: function(res) {}
			});
			//alert(id);
		}
		else
		{
			let newsletter = 0;
			$.ajax({
				type: "post",
				data: {
					"_token": $("input[name='_token']").val(),
					"newsletter": newsletter,
					"email": id
				},
				url:  '/newsletter',
				success: function(res) {}
			});
		}
		//var checkBox = document.getElementById("invtype");
	});

$(document).on('click', '.tourprofilechange',function()
{
	let vid = $("#tourprofilechange").data('id');
	let type ="no";
	if ($(this).prop("checked") == true)
	{
		type ="yes";
	}
	else
	{
		type ="no";
	}
	$(document).ajaxSend(function() 
	{
		$("#overlay").fadeIn(300);　
	});

	$.ajax(
	{
		headers: {
			'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		},
		url:  '/user/tour/save',
		type: 'POST',
		data: 	{
					'type' :type,
					"_token": $("input[name='_token']").val(),
				},
		success: function(response)
		{
		},
		error: function(jqXHR, textStatus, errorThrown, response)
		{
			alert('Internal error: ' + errorThrown);
		}
	}).done(function() 
	{
		setTimeout(function() 
		{
			$("#overlay").fadeOut(300);
		}, 500);
	});
});

$(document).on("click", ".vendor-hidedata", function() 
{
    let i = 0;
    let j = 0;
    let portfolioFlag = 0;
    let testimonialFlag = 0;
    let downloadfile = null;
    let type = $("#previewtype").val();
    let title = localStorage.getItem('Title');
    $('#previweportfolio').html('');
    $('#previwetestimonial').html('');
    let existPortId = [];
    let unapprovedPortId = [];
    let portdata = JSON.parse(localStorage.getItem('allportfolioentries'));
    if (portdata != null) 
    {
        portfolioFlag = 1;
        for (i = 0; i < portdata.length; i++) 
        {
        	existPortId.push(portdata[i]["testimonial"]);
        	unapprovedPortId.push(portdata[i]["templateTestimonial"]);
            let img = '/' + portdata[i]["imagepath"];
            let content = '';
            if (portdata[i]["imagepath"] != undefined) 
            {
                content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + portdata[i]['templateTestimonial'] + '" data-pindex="' + portdata[i]['templateTestimonial'] + '"id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="' + img + '"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + portdata[i]['templateTestimonial'] + '" id="folioauthor-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Author'] + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + portdata[i]['templateTestimonial'] + '" id="foliodesc-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Description'] + '</p></div></a></div>';
            } 
            else 
            {
                content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + portdata[i]['templateTestimonial'] + '" data-pindex="' + portdata[i]['templateTestimonial'] + '"id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="/images/portfolioImg1.svg"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + portdata[i]['templateTestimonial'] + '" id="folioauthor-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Author'] + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + portdata[i]['templateTestimonial'] + '" id="foliodesc-' + portdata[i]['templateTestimonial'] + '">' + portdata[i]['Description'] + '</p></div></a></div>';
            }
            $('#previweportfolio').append(content);
        }
    }
    if (type == 'edit') 
    {
        $(document).ajaxSend(function() 
        {
            $("#overlay").fadeIn(300);
        });
        $.ajax(
        {
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/premium-vendor/data',
            type: 'get',
            success: function(response) 
            {
                let unapprovePortfolio = response.unapprovePortfolio;
                console.log(unapprovePortfolio);
                console.log(unapprovedPortId);
                let portfolio = response.portfolio;
                let testvalues = response.testvalues;
                let testimonial = response.testimonials;
                if (unapprovePortfolio != null && unapprovePortfolio.length > 0) 
                {
                	portfolioFlag = 1;
                    let content = '';
                    for (i = 0; i < unapprovePortfolio.length; i++) 
                    {
                    	if(!(unapprovedPortId.includes(unapprovePortfolio[i].templateTestimonial.toString())))
                    	{
	                        if (unapprovePortfolio[i].imagepath != null) 
	                        {
	                            let img = '/' + unapprovePortfolio[i].imagepath;
	                            content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + unapprovePortfolio[i] + '" data-pindex="' + unapprovePortfolio[i] + '"id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="' + img + '"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + unapprovePortfolio[i] + '" id="folioauthor-' + unapprovePortfolio[i] + '">' + unapprovePortfolio[i].Author + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + unapprovePortfolio[i] + '" id="foliodesc-' + unapprovePortfolio[i] + '">' + unapprovePortfolio[i].Description + '</p></div></a></div>';
	                        } 
	                        else 
	                        {
	                            content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + unapprovePortfolio[i] + '" data-pindex="' + unapprovePortfolio[i] + '" id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="/images/portfolioImg1.svg"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + unapprovePortfolio[i] + '" id="folioauthor-' + unapprovePortfolio[i] + '">' + unapprovePortfolio[i].Author + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + unapprovePortfolio[i] + '" id="foliodesc-' + unapprovePortfolio[i] + '">' + unapprovePortfolio[i].Description + '</p></div></a></div>';
	                        }
	                        $('#previweportfolio').append(content);
	                    }
                    }
                    if(portfolioFlag == 1)
                    {
                    	$(".blogres").show();
                    }
                    else
                    {
                    	$(".blogres").hide();
                    }
                }
                if (portfolio != null && portfolio.length > 0) 
                {
                	portfolioFlag = 1;
                    let content = '';
                    for (i = 0; i < portfolio.length; i++) 
                    {
                    	if(!(existPortId.includes(portfolio[i].portfolio_id.toString())))
                    	{
                    		if (portfolio[i].portfoliomedia != null) 
                    	    {
                    	        let img = '/' + portfolio[i].portfoliomedia.meadiaLink;
                    	        content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + portfolio[i].portfolio_id + '" data-pindex="' + portfolio[i].portfolio_id + '"id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="' + img + '"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + portfolio[i].portfolio_id + '" id="folioauthor-' + portfolio[i].portfolio_id + '">' + portfolio[i].portfolio_title + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + portfolio[i].portfolio_id + '" id="foliodesc-' + portfolio[i].portfolio_id + '">' + portfolio[i].portfolio_description + '</p></div></a></div>';
                    	    } 
                    	    else 
                    	    {
                    	        content = '<div class="col-md-4 col-sm-6 col-lg-3 mb-4 portfolio-preview portfolio-0" data-pid="' + portfolio[i].portfolio_id + '" data-pindex="' + portfolio[i].portfolio_id + '" id="portfolio-0" id="rd"><a href="javascript:void(0)" class="card box-sha text-decoration-none text-dark"><img src="/images/portfolioImg1.svg"  class="card-img-top" alt="..."><div class="card-body"><h4 class="card-title text_limit_one_linepauthor-' + portfolio[i].portfolio_id + '" id="folioauthor-' + portfolio[i].portfolio_id + '">' + portfolio[i].portfolio_title + '</h4><p class="card-text text-justified text-dark fntshowcase text_limit_five_line pdesc-' + portfolio[i].portfolio_id + '" id="foliodesc-' + portfolio[i].portfolio_id + '">' + portfolio[i].portfolio_description + '</p></div></a></div>';
                    	    }
                    	    $('#previweportfolio').append(content);
                    	}
                        
                    }
                    if(portfolioFlag == 1)
                    {
                    	$(".blogres").show();
                    }
                    else
                    {
                    	$(".blogres").hide();
                    }
                } 
                if (testimonial != null && testimonial.length > 0) 
                {
    				testimonialFlag = 1;
                    for (i = 0; i < testimonial.length; i++) 
                    {
                        let content = '';
                        if (testimonial[i].testimonial_by_image != null) 
                        {
                        	let img = '/' + testimonial[i].testimonial_by_image;
                            content += '<div class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv content-item testimonial-block testimonialblock 1" data-td="1" id="1" data-tindex="1" data-tid="0" ><div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' +  img + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testimonial[i].testimonial_by + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">'  + testimonial[i].testimonial_companyName + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + testimonial[i].testimonial + '</h5></div></div></div></div>';
                        } 
                        else 
                        {
                        	let img = '/images/avtar.JPG';
							content += '<div class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv content-item testimonial-block testimonialblock 1" data-td="1" id="1" data-tindex="1" data-tid="0" ><div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' +  img + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testimonial[i].testimonial_by + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">'  + testimonial[i].testimonial_companyName + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + testimonial[i].testimonial + '</h5></div></div></div></div>';
                        }
                        $('#previwetestimonial').append(content);
                    }
                    if(testimonialFlag == 1)
                    {
                    	$(".reviews").show();
                    }
                    else
                    {
                    	$(".reviews").hide();
                    }
                } 
                if (testvalues != null && testvalues.length > 0) 
                {
    				testimonialFlag = 1;
                    for (i = 0; i < testvalues.length; i++) 
                    {
                        let content = '';
                        if (testvalues[i].fileToUpload != null) 
                        {
                        	let img = '/' + testvalues[i].fileToUpload;
                            content += '<div class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv content-item testimonial-block testimonialblock 1" data-td="1" id="1" data-tindex="1" data-tid="0" ><div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' +  img + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testvalues[i].Author + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">'  + testvalues[i].companyName + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + testvalues[i].Description + '</h5></div></div></div></div>';
                        } 
                        else 
                        {
                        	let img = '/images/avtar.JPG';
							content += '<div class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv content-item testimonial-block testimonialblock 1" data-td="1" id="1" data-tindex="1" data-tid="0" ><div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' +  img + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testvalues[i].Author + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">'  + testvalues[i].companyName + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + testvalues[i].Description + '</h5></div></div></div></div>';
                        }
                        $('#previwetestimonial').append(content);
                    }
                    if(testimonialFlag == 1)
                    {
                    	$(".reviews").show();
                    }
                    else
                    {
                    	$(".reviews").hide();
                    }
                } 
                if (response.downloadfiles.length > null) 
                {
                    downloadfile = 1;
                    if (downloadfile != null || downloaddata != null) 
                    {
                        $(".fileDownloadSection").show();
                    } else {
                        $(".fileDownloadSection").hide();
                    }
                }

            }
        }).done(function() {
            setTimeout(function() {
                $("#overlay").fadeOut(300);
            }, 500);
        });
    }
    let desc = localStorage.getItem('Description');
    if (desc == null) {
        $(".previewdescription").hide();
    }
    let address = JSON.parse(localStorage.getItem('addressData'));
    if (address == null) {
        $(".addressdetail").hide();
    }
     
    let testimonialdata = JSON.parse(localStorage.getItem('allEntries'));
    if (testimonialdata != null) 
    {
    	testimonialFlag = 1;
        for (i = 0; i < testimonialdata.length; i++) 
        {
            let content = '';
            if (testimonialdata[i]["fileToUpload"] != undefined && testimonialdata[i]["fileToUpload"] != null) {
                let url = '/' + testimonialdata[i]["fileToUpload"];
                content += ' <div class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv content-item testimonial-block testimonialblock 1" data-td="1" id="1" data-tindex="1" data-tid="0" ><div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' + url + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testimonialdata[i]['Author'] + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">' + testimonialdata[i]['companyName'] + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + testimonialdata[i]['Description'] + '</h5></div></div></div></div>';
            } else {
                let url = '/images/avtar.JPG';
                content += ' <div class="card box-sha col-12 mb-4 p-3 imgfitshow totaldiv content-item testimonial-block testimonialblock 1" data-td="1" id="1" data-tindex="1" data-tid="0" ><div class="card-body"><div class="row p-2"><div class="col-md-1 img"><img src="' + url + '" class="img" id="img-0" /></div><div class="col-md-2"><h5 class="p3 author" data-type="testauthor" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testauthor-0">' + testimonialdata[i]['Author'] + '</h4><h4 class="company" data-type="testcomapny" cjs-badge-type="text" cjs-param="bbbb" data-testindex="2" id="testcomapny-0">' + testimonialdata[i]['companyName'] + '</h4></div><div class="col-md-9"><h5 class="text-justified desc" data-type="testdesc" data-testindex="2" cjs-badge-type="text" cjs-param="bbbb" id="testdesc-0">' + testimonialdata[i]['Description'] + '</h5></div></div></div></div>';
            }
            $('#previwetestimonial').append(content);
        }
    } 
    let downloaddata = JSON.parse(localStorage.getItem('Alldownloadfiles'));
    if (downloadfile != null || downloaddata != null) 
    {
        $(".fileDownloadSection").show();
    } else {
        $(".fileDownloadSection").hide();
    }
    if(portfolioFlag == 1)
    {
    	$(".blogres").show();
    }
    else
    {
    	$(".blogres").hide();
    }
    if(testimonialFlag == 1)
    {
    	$(".reviews").show();
    }
    else
    {
    	$(".reviews").hide();
    }
    $("#pd").hide();
    $("#parentportfolio").hide();
    $(".portfoliobtn").hide();
    $("#previweportfolio").show();
    $("#previwetestimonial").show();
    $("#previwetestimonial").show();
    $('.typebtn').css("display", "none");
    $('.vendor-preview').html('Edit/Create');
    $('.vendor-preview').addClass('vendor-edit');
    $('.vendor-preview').removeClass('hidedata');
    $('.index').removeClass('closefile');
    $(".address-block").removeClass('editvendorprofile');
    $(".address-block").removeClass('addvendorprofile');
    $(".testimonial-block").removeClass('testimonialblock');
    $("#title").removeClass('cjs-change-title');
    $("#tagline").removeClass('cjs-change-title');
    $("#desc").removeClass('cjs-change-title');
    $("#desc").removeClass('cjs-allow-change');
    $(".del").hide();
    $(".remo").hide();
    $(".vendorsliderimages").hide();
    $(".uploadarea").hide();
    $(".testimonialaddbtn").hide();
    $(".inventoraddbtn").hide();
    $(".slider-block").removeClass('sliderimages');
    $(".slider-block").removeClass('vendorsliderimages');
});

$(document).on("click", ".vendor-edit", function()
{
	$('.index').addClass('closefile');
    $(".blogres").show();
    $(".blogres").css('display', 'block');
    $(".vendorsliderimages").show();
    $('#slidshow').css("display", "block");
    $(".addressdetail").show();
    $(".previewdescription").show();
    $(".vendorsliderimages").show();
    $(".fileDownloadSection").show();
    $(".reviews").show();
    $(".reviews").css("display", "block");
    $(".portfoliobtn").show();
    $('.typebtn').css("display", "inline-flex");
    $("#parentportfolio").show();
    $("#previweportfolio").hide();
    $("#previwetestimonial").hide();
    $("#previwedownload").hide();
    $("#pd").show();
    $(".slider-block").addClass('vendorsliderimages');
    $('.vendor-preview').html('Preview');
    $('.vendor-preview').removeClass('vendor-edit');
    $(".address-block").addClass('addvendorprofile');
    $(".address-block").addClass('editvendorprofile');
    $('.vendor-preview').addClass('vendor-hidedata');
    $(".category-block").addClass('categorychange');
    $(".testimonial-block").addClass('testimonialblock');
    $("#title").addClass('cjs-change-title');
    $("#tagline").addClass('cjs-change-title');
    $("#desc").addClass('cjs-change-title ');
    $(".del").show();
    $(".remo").show();
    $(".uploadarea").show();
    $(".testimonialaddbtn").show();
    $(".inventoraddbtn").show();
    $(".slider-block").addClass('sliderimages');
    $("#preblogres").show();
    $("#preblogres").css('display', 'block');
});
$(document).on("change", "#countryzipdata", function()
{
  	$("#statedata").empty();
  	$("#city").empty();
  	$("#places").empty();
  	$("#zipcode").val('');
  	$('#zipstatus').prop('checked', true);
	$('#statedata').prop('readonly', true);
    $('#statedata option').prop('readonly', true);
    $('#city').prop('readonly', true);
    $('#city option').prop('readonly', true);
    $('#zipcode').prop('readonly', false);
    $('.stateLabel').text('State');
    $('.cityLabel').text('City');
    $('.placeLabel').text('Place');
    let  currentInput = $('#zipcode');
    let  newInput = $('<input>').attr(
    	{
            'type': 'text',
            'id': currentInput.attr('id'),
            'class': currentInput.attr('class'),
            'name': currentInput.attr('name'),
            'value': currentInput.val()
     	});
    currentInput.after(newInput); 
    currentInput.remove();
});

$(document).on("change", ".zipdata", function()
{
  	let zipcode = $(".zipdata").val();
  	let country = $("#countryzipdata").val();
  	if(zipcode == '000000')
  	{
  		$(document).ajaxSend(function() 
  		{
  			$("#overlay").fadeIn(300);　
  		});
  		$.ajax(
  		{
  			type:"get",
  			url:'/getStates/'+country,
  			success:function(response)
  			{
  				if(response)
  				{
  					$("#statedata").empty();
  					$("#city").empty();
  					$("#places").empty();
  					$("#statedata").append('<option>Select State</option>');
  					$.each(response,function(key,value)
  					{
  						$("#statedata").append('<option value="'+value+'">'+key+'</option>');
  					});
  				}
  			}
  		}).done(function() 
  		{
  			setTimeout(function() 
  			{
  				$("#overlay").fadeOut(300);
  			}, 500);
  		});
  	}
  	else
  	{
  		$(document).ajaxSend(function() 
  		{
  			$("#overlay").fadeIn(300);　
  		});
  		$.ajax(
  		{
  			headers: {
  				'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  			},
  			url:  '/zipcode/search',
  			type: 'POST',
  			data: 	{
  						'zipcode' :zipcode,
  						'country' :country,
  					},
  			success: function(response)
  			{
  				if(response)
  				{
  					if(response.addressData == null)
  					{
  						alert("Zipcode did not match with the selected country.");
  						$("#zipcode").val('');
  						$("#statedata").empty();
  						$("#city").empty();
  						$("#places").empty('');
  					}
  					else
  					{
  						let address = response.addressData;
  						let places = response.placesData;
  						$("#statedata").empty();
  						$("#city").empty();
  						$("#statedata").append('<option value="'+address.state_id+'"  selected>'+address.state_name+'</option>');
  						$("#city").append('<option value="'+address.city_id+'" selected>'+address.city_name+'</option>');
  						$("#places").empty();
  						$.each(response.placesData,function(key,value)
  						{
  							$("#places").append('<option value="'+value+'">'+key+'</option>');
  						});
  					}
  					
  					
  				}
  			},
  			error: function(jqXHR, textStatus, errorThrown, response)
  			{
  				alert('Internal error: ' + errorThrown);
  			}
  		}).done(function() 
  		{
  			setTimeout(function() 
  			{
  				$("#overlay").fadeOut(300);
  			}, 500);
  		});
  	}
  	
});

$(document).on("change", "#places", function()
{
  	let place = $("#places").val();
  	$(document).ajaxSend(function() 
  	{
  		$("#overlay").fadeIn(300);　
  	});
  	$.ajax(
  	{
  		type:"get",
  		url:'/getZipcode/'+place,
  		success:function(response)
  		{
  			if(response)
  			{
  				$("#zipcode").val(response.postal_code);
  			}
  		}
  	}).done(function() 
  		{
  			setTimeout(function() 
  			{
  				$("#overlay").fadeOut(300);
  			}, 500);
  		});
});
$(document).on("click", ".zipstatus", function()
{
	let zipcode = $(".zipdata").val();
	let country = $("#countryzipdata").val();
    if ($(this).prop("checked") == true)
    {
        $('#statedata').prop('readonly', true);
        $('#statedata option').prop('readonly', true);
        $('#city').prop('readonly', true);
        $('#city option').prop('readonly', true);
        $('#zipcode').prop('readonly', false);
        $('.stateLabel').text('State');
        $('.cityLabel').text('Province');
        $('.placeLabel').text('City');
    	$('.placefield').css('display', 'block');
        let  currentInput = $('#zipcode');
        let  newInput = $('<input>').attr({
            'type': 'text',
            'id': currentInput.attr('id'),
            'class': currentInput.attr('class'),
            'name': currentInput.attr('name'),
            'value': currentInput.val()
          });

        currentInput.after(newInput); 
        currentInput.remove();
    	$("#statedata").empty();
    	$("#city").empty();
    	$("#places").empty();
    	$("#zipcode").val(''); 
    }
    else
    {
    	$(document).ajaxSend(function() 
    	{
    		$("#overlay").fadeIn(300);　
    	});
    	$.ajax(
    	{
    		type:"get",
    		url:'/getStates/'+country,
    		success:function(response)
    		{
    			if(response)
    			{
    				$("#statedata").empty();
    				$("#city").empty();
    				$("#places").empty();
    				$("#statedata").append('<option>Select State</option>');
    				$.each(response,function(key,value)
    				{
    					$("#statedata").append('<option value="'+value+'">'+key+'</option>');
    				});
    			}
    			$('#statedata').prop('readonly', false);
        		$('#statedata option').prop('readonly', false);
        		$('#statedata').prop('disabled', false);
        		$('#statedata option').prop('disabled', false);
        		$('#city').prop('readonly', false);
        		$('#city option').prop('readonly', false);
        		$('#places').prop('readonly', false);
        		$('#places option').prop('readonly', false);
    			$('#zipcode').prop('readonly', true);
    			$('#city').prop('disabled', false);
    			$('#city option').prop('disabled', false);
    			$('#places').prop('disabled', false);
    			$('#places option').prop('disabled', false);
    			$('#zipcode').prop('disabled', true);
    			$('.stateLabel').text('Select State');
    			$('.cityLabel').text('Select City');
    			$('.placeLabel').text('Select Place');
    			$('.placefield').css('display', 'none');
    			let  currentInput = $('#zipcode');
    			let  newInput = $('<input>').attr({
    			    'type': 'hidden',
    			    'id': currentInput.attr('id'),
    			    'class': currentInput.attr('class'),
    			    'name': currentInput.attr('name'),
    			    'value': currentInput.val()
    			  });

    			currentInput.after(newInput); 
    			currentInput.remove();
    		}
    	}).done(function() 
    	{
    		setTimeout(function() 
    		{
    			$("#overlay").fadeOut(300);
    		}, 500);
    	});
    	
    }
});
$("#overlay").fadeOut(300);

 	$(document).on("click", ".removevendorsliderimage", function()
 	{
    	localStorage.setItem('vendorkey',true);
 		let id = $(this).data('fid');
 		$("."+id).remove();
 		let deletefilelist = [];
 		let del_file = [];
 		let test_rows = [];
 		let test_line = null;
 		let existingdeletefile = JSON.parse(localStorage.getItem("deletefilelist"));
 		if(existingdeletefile == null)
 		{
 			existingdeletefile = [];
 		} 
 		let temp = [];
 		if(existingdeletefile.length != 0)
		{
		 	for(let i = 0; i < existingdeletefile.length; i++)
		 	{
		  		if(existingdeletefile[i]['fid'] == id)
		  		{
					temp = existingdeletefile[i];
					existingdeletefile.splice(i,1);
		  		}
		 	}
		}
		if(temp.length != '0')
		{
		  	if(temp['id'] == id)
		  	{
		   		test_line = {};
		   		test_line.fid = temp['fid'];
		   		test_rows.push(test_line);
		   		localStorage.setItem("deletefiletemp",JSON.stringify(test_rows));
		   		existingdeletefile.push(test_line);
   				localStorage.setItem("deletefilelist", JSON.stringify(existingdeletefile));
 			}
 			else
 			{
  				test_line = {};
  				test_line.fid = id;
  				test_rows.push(test_line);
  				localStorage.setItem("deletefiletemp",JSON.stringify(test_rows));
  				existingdeletefile.push(test_line);
  				localStorage.setItem("deletefilelist", JSON.stringify(existingdeletefile));
 			}
 		}
		else
		{
		 	test_line = {};
		 	test_line.fid = id;
		 	test_rows.push(test_line);
		 	localStorage.setItem("deletefiletemp",JSON.stringify(test_rows));
		 	existingdeletefile.push(test_line);
		 	localStorage.setItem("deletefilelist", JSON.stringify(existingdeletefile));
		}
 
 		let deletedata = localStorage.getItem("deletefilelist");
 		let media_id = localStorage.getItem("sliderfiles"); 
 		let formData = new FormData();
 		formData.append("media_id", media_id);
 		formData.append("deletedata",deletedata);
 		formData.append("invid", $("#vendorid").val());
 
		$(document).ajaxSend(function() 
		{
		 	$("#overlay").fadeIn(300);　
		});
		$.ajax(
		{
		 	headers: {
		  	'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
		 	},
		 	url:'/vendorsliderremovefiles' ,
		 	type: 'POST',
		 
		 	data: formData,
		 	contentType: false,
		 	processData: false,
		 	success: function(response)
		 	{
  				let file_row = [];
			   	let existfiles = JSON.parse(localStorage.getItem("sliderfiles"));
			   	if(existfiles == null)
			   	{
					existfiles = [];
			   	} 
			  	let media_id = [];
			  	let media = response.medias;
			  	let existmedias = response.existmedias;
			 	let type = response.type;
			  	let mediacount = response.medias;
			  	let slide = 0;
			  	let i = 0;
				for (i = 0; i < mediacount.length; i++) 
				{
				  	if(mediacount[i].fileType != '1')
				  	{
				 	 	slide = slide+1;
				  	}
				}
				for (i = 0; i < response.existmedias.length; i++) 
				{
				  	if(existmedias[i].fileType != '1')
				  	{
				  		slide = slide+1;
				  	}
				}
  				let record = "<table>"
				if(existmedias.length != 0)
				{
				   for (i = 0; i < existmedias.length; i++) 
				   {
					  if(existmedias[i].fileType == '1')
					  {
						  record += "<tr class='"+existmedias[i].id+"'><td><iframe src='" +existmedias[i].mediaLink+ ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='"+existmedias[i].vendormedia_id+"'><i class='fa fa-trash-o'></i></button></td><tr><tr></tr>";
				 
					  }
					  else
					  {
					  	if(type == 1)
					  	{
							if(i  == 0 )
						  	{

							  record += '<tr class="'+existmedias[i].id+'"><td><img src="' +'/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><input data-invid="'+invid+'" data-imgid="'+ existmedias[i].id +'"  id="vendorprofileslide" class="vendorprofileslide" type="file" hidden/><td><a href="javascript:void(0);" class="btn btn-warning vendorprofileslider" id="vendorprofileslider" data-fid="'+ existmedias[i].vendormedia_id +'"><i class="fa fa-edit"></i></a></td></tr><tr></tr>';
							}
						  	else
						  	{
						  		 record += '<tr class="'+existmedias[i].id+'"><td><img src="' +'/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="'+ existmedias[i].vendormedia_id +'"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
						  	}
					  	}
					  	else
					  	{
					  		if(slide < 2 )
						  	{

							  record += '<tr class="'+existmedias[i].id+'"><td><img src="' +'/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><tr><tr></tr>';
						  	}
						  	else
						  	{
						  		 record += '<tr class="'+existmedias[i].id+'"><td><img src="' +'/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="'+existmedias[i].vendormedia_id+'"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
						  	}
					  	}
					  	
					  }
				   }
				  }
				  for (i = 0; i < media.length; i++) 
				  {
				   if(media[i].fileType == '1')
				   {
					  record += "<tr class='"+media[i].id+"'><td><iframe src='" +media[i].mediaLink+ ".'?autoplay=1&mute=1&enablejsapi=1&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1' frameborder='0' allowfullscreen data-autoplay='false' height='60px' width='180px'></iframe></td><td>&nbsp;</td><td><button class='btn btn-danger removevendorsliderimage' data-fid='"+media[i].vendormedia_id+"'><i class='fa fa-trash-o'></i></button></td><tr><tr></tr>";
				 
				   }
				   else
				   {
				   		if(type == 1)
					  	{
							if(i  == 0 )
						  	{

							  record += '<tr class="'+existmedias[i].id+'"><td><img src="' +'/' + existmedias[i].mediaLink + '" alt="Image" class="img-fluid" height="50px" width="50px" style="height:50px;width:50px;"></td><td>&nbsp;</td><input data-invid="'+invid+'" data-imgid="'+ existmedias[i].id +'"  id="vendorprofileslide" class="vendorprofileslide" type="file" hidden/><td><a href="javascript:void(0);" class="btn btn-warning vendorprofileslider" id="vendorprofileslider" data-fid="'+existmedias[i].vendormedia_id+'"><i class="fa fa-edit"></i></a></td></tr><tr></tr>';
							}
						  	else
						  	{
						  		 record += '<tr class="'+media[i].id+'"><td><img src="' +'/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="'+media[i].vendormedia_id+'"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
						  	}
					  	}
					  	else
					  	{
						   	if(slide < 2 )
							{
							  record += '<tr class="'+media[i].id+'"><td><img src="' +'/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><tr><tr></tr>';
							}
							else
							{
								record += '<tr class="'+media[i].id+'"><td><img src="' +'/' + media[i].mediaLink + '" alt="Image" class="img-fluid" height="60px" width="180px" style="height:60px;width:180px;"></td><td>&nbsp;</td><td><button class="btn btn-danger removevendorsliderimage" data-fid="'+media[i].vendormedia_id+'"><i class="fa fa-trash-o"></i></button></td><tr><tr></tr>';
							}
						}
				   }
				 
				   existfiles.push(media[i].id);
				   localStorage.setItem("sliderfiles", JSON.stringify(existfiles));
				  }
				  
				  $('#newdata').html(record);
				  $('.sliderarea').html(response.html);
				    var nsOptions =
				    {
				  	  sliderId: "ninja-slider2",
				  	  transitionType: "fade",
				  	  autoAdvance: true,
				  	  rewind: true,
				  	  delay: 10000,
				  	  transitionSpeed: 5000,
				  	  aspectRatio: "2:1", // "?:100%" is for responsive scaling based on window height
				  	  initSliderByCallingInitFunc: false,
				  	  shuffle: false,
				  	  startSlideIndex: 0, //0-based
				  	  navigateByTap: false,
				  	  pauseOnHover: false,
				  	  keyboardNav: true,
				  	  before: null,
				  	  license: ninjaSliderKey
				    };
				  var nslider = new NinjaSlider(nsOptions);//function call
				  function NinjaSlider(a){"use strict";if(typeof String.prototype.trim!=="function")String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")};var e="length",t=a.sliderId,pb=function(d){var a=d.childNodes,c=[];if(a)for(var b=0,f=a[e];b<f;b++)a[b].nodeType==1&&c.push(a[b]);return c},E=function(b,a){return b.getAttribute(a)},db=function(a,b){return a.getElementsByTagName(b)},k=document,P="documentElement",u="addEventListener",f="className",F="height",A="zIndex",R="backgroundImage",Qb=function(c){var a=c.childNodes;if(a&&a[e]){var b=a[e];while(b--)a[b].nodeType!=1&&a[b][y].removeChild(a[b])}},x=function(a,c,b){if(a[u])a[u](c,b,false);else a.attachEvent&&a.attachEvent("on"+c,b)},yb=function(d,c){for(var b=[],a=0;a<d[e];a++)b[b[e]]=String[nb](d[ab](a)-(c?c:3));return b.join("")},sb=function(a){if(a&&a.stopPropagation)a.stopPropagation();else if(window.event)window.event.cancelBubble=true},rb=function(b){var a=b||window.event;if(a.preventDefault)a.preventDefault();else if(a)a.returnValue=false},Tb=function(b){if(typeof b[d].webkitAnimationName!="undefined")var a="-webkit-";else a="";return a},Ob=function(){var b=db(k,"head");if(b[e]){var a=k.createElement("style");b[0].appendChild(a);return a.sheet?a.sheet:a.styleSheet}else return 0},J=function(){return Math.random()},Ab=["$1$2$3","$1$2$3","$1$24","$1$23","$1$22"],Yb=function(a){return a.replace(/(?:.*\.)?(\w)([\w\-])?[^.]*(\w)\.[^.]*$/,"$1$3$2")},zb=[/(?:.*\.)?(\w)([\w\-])[^.]*(\w)\.[^.]+$/,/.*([\w\-])\.(\w)(\w)\.[^.]+$/,/^(?:.*\.)?(\w)(\w)\.[^.]+$/,/.*([\w\-])([\w\-])\.com\.[^.]+$/,/^(\w)[^.]*(\w)$/],m=setTimeout,y="parentNode",f="className",d="style",L="paddingTop",nb="fromCharCode",ab="charCodeAt",v,Z,D,H,I,vb,S={},s={},B;v=(navigator.msPointerEnabled||navigator.pointerEnabled)&&(navigator.msMaxTouchPoints||navigator.maxTouchPoints);Z="ontouchstart"in window||window.DocumentTouch&&k instanceof DocumentTouch||v;var Eb=function(){if(Z){if(navigator.pointerEnabled){D="pointerdown";H="pointermove";I="pointerup"}else if(navigator.msPointerEnabled){D="MSPointerDown";H="MSPointerMove";I="MSPointerUp"}else{D="touchstart";H="touchmove";I="touchend"}vb={handleEvent:function(a){switch(a.type){case D:this.a(a);break;case H:this.b(a);break;case I:this.c(a)}sb(a)},a:function(a){b[c][d][h?"top":"left"]="0";if(v&&a.pointerType!="touch")return;N();var e=v?a:a.touches[0];S={x:e.pageX,y:e.pageY,t:+new Date};B=null;s={};g[u](H,this,false);g[u](I,this,false)},b:function(a){if(!v&&(a.touches[e]>1||a.scale&&a.scale!==1))return;if(v&&a.pointerType!="touch")return;var f=v?a:a.touches[0];s[h?"y":"x"]=f.pageX-S.x;s[h?"x":"y"]=f.pageY-S.y;if(v&&Math.abs(s.x)<21)return;if(B===null)B=!!(B||Math.abs(s.x)<Math.abs(s.y));!B&&rb(a);b[c][d][h?"top":"left"]=s.x+"px"},c:function(){var f=+new Date-S.t,e=f<250&&Math.abs(s.x)>20||Math.abs(s.x)>99;if(a.n&&(c==r-1&&s.x<0||!c&&s.x>0))e=0;B===null&&a.navigateByTap&&!b[c].player&&n(c+1,1);if(B===false)if(e)n(c+(s.x>0?-1:1),1);else{b[c][d][h?"top":"left"]="0";wb()}g.removeEventListener(H,this,false);g.removeEventListener(I,this,false)}};g[u](D,vb,false)}},i={};i.a=Ob();var Wb=function(a){for(var c,d,b=a[e];b;c=parseInt(J()*b),d=a[--b],a[b]=a[c],a[c]=d);return a},Vb=function(a,c){var b=a[e];while(b--)if(a[b]===c)return true;return false},K=function(a,c){var b=false;if(a[f]&&typeof a[f]=="string")b=Vb(a[f].split(" "),c);return b},o=function(a,b,c){if(!K(a,b))if(a[f]=="")a[f]=b;else if(c)a[f]=b+" "+a[f];else a[f]+=" "+b},C=function(c,g){if(c[f]){for(var d="",b=c[f].split(" "),a=0,h=b[e];a<h;a++)if(b[a]!==g)d+=b[a]+" ";c[f]=d.trim()}},gb=function(a){if(a[f])a[f]=a[f].replace(/\s?sl-\w+/g,"")},Gb=function(){var a=this;if(a[f])a[f]=a[f].replace(/sl-s\w+/,"ns-show").replace(/sl-c\w+/,"")},q=function(a){a="#"+t+a.replace("__",i.p);i.a.insertRule(a,0)},Sb=function(a){var b=Yb(document.domain.replace("www.",""));try{typeof atob=="function"&&(function(a,c){var b=yb(atob("dy13QWgsLT9taixPLHowNC1BQStwKyoqTyx6MHoycGlya3hsMTUtQUEreCstd0E0P21qLHctd19uYTJtcndpdnhGaWpzdmksbV9rKCU2NiU3NSU2RSUlNjYlNzUlNkUlNjMlNzQlNjklNkYlNkUlMjAlNjUlMjglKSo8Zy9kYm1tKXVpanQtMio8aCkxKjxoKTIqPGpnKW4+SylvLXAqKnx3YnMhcz5OYnVpL3Nib2VwbikqLXQ+ZAFeLXY+bCkoV3BtaGl2JHR5dmdsZXdpJHZpcW1yaGl2KCotdz4ocWJzZm91T3BlZig8ZHBvdHBtZi9tcGgpcyo8amcpdC9vcGVmT2JuZj4+KEIoKnQ+ayl0KgE8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11KC12KjxmbXRmIWpnKXM/LzgqfHdic3I+ZXBkdm5mb3UvZHNmYnVmVWZ5dU9wZWYpdiotRz5td3I1PGpnKXM/Lzg2Kkc+R3cvam90ZnN1Q2ZncHNmKXItRypzZnV2c28hdWlqdDw2OSU2RiU2RSU8amcpcz8vOSp0L3RmdUJ1dXNqY3Z1ZikoYm11cGR2bmYlJG91L2RzZmJ1ZlVmeQ=="),a[e]+parseInt(a.charAt(1))).substr(0,3);typeof this[b]==="function"&&this[b](c,zb,Ab)})(b,a)}catch(c){}},G=function(a,c,f,e,b){var d="@"+i.p+"keyframes "+a+" {from{"+c+";} to{"+f+";}}";i.a.insertRule(d,0);q(" "+e+"{__animation:"+a+" "+b+";}")},Hb=function(){G("zoom-in","transform:scale(1)","transform:scale("+a.scale+")","li.ns-show .ns-img",a.e+l+"ms 1 alternate none");V();q(" ul li .ns-img {background-size:cover;}")},Fb=function(){var c=a.e*100/(a.e+l),b="@"+i.p+"keyframes zoom-in {0%{__transform:scale(1.4);__animation-timing-function:cubic-bezier(.1,1.2,.02,.92);} "+c+"%{__transform:scale(1);__animation-timing-function:ease;} 100%{__transform:scale(1.1);}}";b=b.replace(/__/g,i.p);i.a.insertRule(b,0);q(" li.ns-show .ns-img {__animation:zoom-in "+(a.e+l)+"ms 1 alternate both;}");V();q(" ul li .ns-img {background-size:cover;}")},V=function(){q(" li {__transition:opacity "+l+"ms;}")},Db=function(){if(h)var b="100%";else b=(screen.width/(1.5*g[y].offsetWidth)+.5)*100+"%";var c=l+"ms ease both";if(a.c!="slide"&&!h&&l>294)c="294ms ease both";var k=i.p+"transform:translate"+(h?"Y":"X")+"(",f=k+b+")",e=k+"-"+b+")",d=function(a,b){return a?b?f:e:k+"0)"},j=function(g,c,a,b){G("sl-cl"+a,d(b,1),e,"li.sl-cl"+a,c);G("sl-cr"+a,d(b,0),f,"li.sl-cr"+a,c);G("sl-sl"+a,f,d(b,0),"li.sl-sl"+a,c);G("sl-sr"+a,e,d(b,1),"li.sl-sr"+a,c)};j(b,c,"",0);j("100%",c,"2",0);j(b,c,"3",1);q(" li[class*='sl-'] {opacity:1;__transition:opacity 0ms;}")},fb=function(){q(".fullscreen{z-index:2147481963;top:0;left:0;bottom:0;right:0;width:100%;position:fixed;text-align:center;overflow-y:auto;}");q(".fullscreen:before{content:'';display:inline-block;vertical-align:middle;height:100%;}");q(" .fs-icon{cursor:pointer;position:absolute;z-index:99999;}");q(".fullscreen .fs-icon{position:fixed;top:6px;right:6px;}");q(".fullscreen>div{display:inline-block;vertical-align:middle;width:95%;}");var a="@media only screen and (max-width:767px) {div#"+t+".fullscreen>div{width:100%;}}";i.a.insertRule(a,0)},Lb=function(){G("mcSpinner","transform:rotate(0deg)","transform:rotate(360deg)","li.loading::after",".6s linear infinite");q(" li.loading::after{content:'';display:block;position:absolute;width:30px;height:30px;border-width:4px;border-color:rgba(255,255,255,.8);border-style:solid;border-top-color:black;border-right-color:rgba(0,0,0,.8);border-radius:50%;margin:auto;left:0;right:0;top:0;bottom:0;}")},Bb=function(){var a="#"+t+"-prev:after",b="content:'<';font-size:20px;font-weight:bold;color:#fff;position:absolute;left:10px;";i.a.addRule(a,b,0);i.a.addRule(a.replace("prev","next"),b.replace("<",">").replace("left","right"),0)},cb=function(b){var a=r;return b>=0?b%a:(a+b%a)%a},p=null,g,j,h,O,b=[],T,hb,bb,w,U,M,xb,z=false,c=0,r=0,l,Ub=function(a){return!a.complete?0:a.width===0?0:1},jb=function(b){if(b.rT){g[d][L]=b.rT;if(a.g!="auto")b.rT=0}},qb=function(e,c,b){if(!j.vR&&(a.g=="auto"||g[d][L]=="50.1234%")){b.rT=c/e*100+"%";g[d][L]=="50.1234%"&&jb(b)}},Pb=function(b,n){if(b.lL===undefined){var p=screen.width,l=db(b,"*");if(l[e]){for(var g=[],a,i,h,c=0;c<l[e];c++)K(l[c],"ns-img")&&g.push(l[c]);if(g[e])a=g[0];else b.lL=0;if(g[e]>1){for(var c=1;c<g[e];c++){h=E(g[c],"data-screen");if(h){h=h.split("-");if(h[e]==2){if(h[1]=="max")h[1]=9999999;if(p>=h[0]&&p<=h[1]){a=g[c];break}}}}for(var c=0;c<g[e];c++)if(g[c]!==a)g[c][d].display="none"}if(a){b.lL=1;if(a.tagName=="A"){i=E(a,"href");x(a,"click",rb)}else if(a.tagName=="IMG")i=E(a,"src");else{var k=a[d][R];if(k&&k.indexOf("url(")!=-1){k=k.substring(4,k[e]-1).replace(/[\'\"]/g,"");i=k}}if(E(a,"data-fs-image")){b.nIs=[i,E(a,"data-fs-image")];if(K(j,"fullscreen"))i=b.nIs[1]}if(i)b.nI=a;else b.lL=0;var f=new Image;f.onload=f.onerror=function(){var a=this;if(a.mA){if(a.width&&a[F]){if(a.mA.tagName=="A")a.mA[d][R]="url('"+a.src+"')";qb(a.naturalWidth||a.width,a.naturalHeight||a[F],a.mL);C(a.mL,"loading")}a.is1&&Y();m(function(){a=null},20)}};f.src=i;if(Ub(f)){C(b,"loading");qb(f.naturalWidth,f.naturalHeight,b);n===1&&Y();if(a.tagName=="A")a[d][R]="url('"+i+"')";f=null}else{f.is1=n===1;f.mA=a;f.mL=b;o(b,"loading")}}}else b.lL=0}b.lL===0&&n===1&&Y()},lb=function(a){for(var e=a===1?c:c-1,d=e;d<e+a;d++)Pb(b[cb(d)],a);a==1&&Jb()},kb=function(){if(p)nsVideoPlugin.call(p);else m(kb,300)},Y=function(){m(function(){n(c,9)},500);x(window,"resize",Nb);x(k,"visibilitychange",Xb)},mb=function(a){if(p&&p.playAutoVideo)p.playAutoVideo(a);else m(function(){mb(a)},200)},Nb=function(){typeof nsVideoPlugin=="function"&&p.setIframeSize();if(j.vR)j[d][F]=j.vR*k[P].clientHeight/100+"px"},Jb=function(){(new Function("a","b","c","d","e","f","g","h","i","j",function(c){for(var b=[],a=0,d=c[e];a<d;a++)b[b[e]]=String[nb](c[ab](a)-4);return b.join("")}("zev$NAjyrgxmsr,|0}-zev$eAjyrgxmsr,~-zev$gA~_fa,4-2xsWxvmrk,-?vixyvr$g2wyfwxv,g2pirkxl15-\u0081?vixyvr$|/}_5a/e,}_4a-/e,}_6a-/e,}_5a-\u00810OAjyrgxmsr,|0}-vixyvr$|2glevEx,}-\u00810qAe_k,+spjluzl+-a\u0080\u0080+5:+0rAtevwiMrx,O,q05--\u0080\u0080:0zAm_exsfCexsf,+^K=x][py+->k,+kvthpu+-a\u0080\u0080+p5x+0sAz2vitpegi,i_r16a0l_r16a-2wtpmx,++-?j2tAh,g-?mj,q%AN,+f+/r0s--zev$vAQexl2verhsq,-0w0yAk,+Upuqh'Zspkly'{yphs'}lyzpvu+-?mj,v@27-wAg_na_na2tvizmsywWmfpmrk?mj,v@2:**%w-wAg_na_na_na?mj,w**w2ri|xWmfpmrk-wAw2ri|xWmfpmrk\u0081mj,vB2=-wAm2fsh}?mj,O,z04-AA+p+**O,z0z2pirkxl15-AA+x+-wA4?mj,w-w_na2mrwivxFijsvi,m_k,+jylh{l[l{Uvkl+-a,y-0w-\u0081"))).apply(this,[a,ab,g,Tb,zb,i,yb,Ab,document,y])},n=function(c,d){if(b[e]==1&&c>0)return;a.pauseOnHover&&clearTimeout(bb);p&&p.unloadPlayer&&p.unloadPlayer();tb(c,d)},Q=function(){z=!z;xb[f]=z?"paused":"";!z&&n(c+1,0);return z},Xb=function(){if(a.d)if(z){if(p.iframe&&p.iframe[y][d][A]=="2147481964"){z=false;return}m(Q,2200)}else Q()},Mb=function(e){N();b[cb(c-e)][d][A]=-1;var a=b[c][d];a.transition=h?"top":"left .16s";a[h?"top":"left"]=-14*e+"%";m(function(){a[h?"top":"left"]="0%";m(function(){a.transition=""},160);wb()},160)},eb=function(){var a=this.id.indexOf("-prev")==-1?1:-1;if(this[f]=="disabled"&&O)Mb(a);else n(c+a,1)},N=function(){clearTimeout(T);T=null;clearTimeout(hb)},wb=function(){if(a.d)T=m(function(){n(c+1,0)},a.e)};function Ib(b){if(!b)b=window.event;var a=b.keyCode;(a==37||h&&a==38)&&n(c-1,1);(a==39||h&&a==40)&&n(c+1,1)}var ub=function(f){var e=this;g=f;Kb();Sb(a.a);if(a.pauseOnHover&&a.d){g.onmouseover=function(){clearTimeout(bb);N()};g.onmouseout=function(){if(e.iframe&&e.iframe[y][d][A]=="2147481964")return;bb=m(function(){n(c+1,1)},2e3)}}if(a.c!="slide")g[d].overflow="hidden";e.d();e.c();typeof nsVideoPlugin=="function"&&kb();r>1&&Eb();e.addNavs();lb(1);if(i.a){var j=k.all&&!atob;if(i.a.insertRule&&!j){if(a.c=="fade")V();else if(a.c=="zoom")Fb();else a.c=="kb"&&Hb();O&&Db();D&&D.indexOf("ointer")!=-1&&q(" UL {-ms-touch-action:pan-"+(h?"x":"y")+";touch-action:pan-"+(h?"x":"y")+";}");fb();Lb()}else if(k.all&&!k[u]){Bb();i.a.addRule("div.fs-icon","display:none!important;",0);i.a.addRule("#"+t+" li","visibility:hidden;",0);i.a.addRule("#"+t+" li[class*='sl-s']","visibility:visible;",0);i.a.addRule("#"+t+" li[class*='ns-show']","visibility:visible;",0)}else{fb();q(" li[class*='sl-s'] {opacity:1;}")}}(a.c=="zoom"||a.c=="kb")&&b[0].nI&&ib(b[0].nI,0,b[0].dL);o(b[0],"ns-show sl-0");a.keyboardNav&&r>1&&x(k,"keydown",Ib)},Kb=function(){a.c=a.transitionType;a.a=a.license;a.d=a.autoAdvance;a.e=a.delay;a.g=a.aspectRatio;h=a.c.indexOf("verti")!=-1;if(a.c.indexOf("kenburns")!=-1){var c=a.c.split(" ");a.c="kb";a.scale=1.2;if(c[e]>1)a.scale=parseFloat(c[1])}if(a.pauseOnHover)a.navigateByTap=0;if(typeof a.m=="undefined")a.m=1;if(typeof a.n=="undefined")a.n=1;O=a.c=="slide"||h||a.m;if(a.c=="none"){a.c="fade";a.transitionSpeed=0}var b=a.e;if(b==="default")switch(a.c){case"kb":case"zoom":b=6e3;break;default:b=3500}l=a.transitionSpeed;if(l==="default")switch(a.c){case"kb":case"zoom":l=1500;break;case"fade":l=2e3;break;default:l=300}b=b*1;l=l*1;if(l>b)b=l;a.e=b},Zb=function(a,b){if(!a||a=="default")a=b;return a},ib=function(b){var l=J(),f=J(),g=J(),h=J(),j=l<.5?"alternate":"alternate-reverse";if(f<.3)var c="left";else if(f<.6)c="center";else c="right";if(g<.45)var e="top";else if(g<.55)e="center";else e="bottom";if(h<.2)var i="linear";else i=h<.6?"cubic-bezier(.94,.04,.94,.49)":"cubic-bezier(.93,.2,.87,.52)";var k=c+" "+e;b[d].WebkitTransformOrigin=b[d].transformOrigin=k;if(a.c=="kb"){b[d].WebkitAnimationDirection=b[d].animationDirection=j;b[d].WebkitAnimationTimingFunction=b[d].animationTimingFunction=i}},Cb=function(b){if(M){U.innerHTML=M.innerHTML="<div>"+(b+1)+" &#8725; "+r+"</div>";U[f]=b?"":"disabled";M[f]=b==r-1?"disabled":"";if(!a.n)U[f]=M[f]="";if(w[e]){var c=w[e];while(c--)w[c][f]="";w[b][f]="active"}}},X=function(f,a,e,c){(c&&a<e||!c&&a>e)&&m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-c"+(c?"l3":"r3"));X(f,a+(c?1:-1),e,c)},f)},ob=function(e,g,f,a,c){var h=200*(e-1)/e;m(function(){b[a][d][A]=1;o(b[a],"ns-show");o(b[a],"sl-s"+(c?"l":"r")+g)},200);hb=m(function(){for(var h=c?f:a+1,i=c?a:f+1,g=h;g<i;g++){var e=b[g];gb(e);C(e,"ns-show");e[d][A]=-1}},l)},tb=function(e,p){e=cb(e);if(!p&&(z||e==c))return;N();b[e][d][h?"top":"left"]="0";for(var k=0,u=r;k<u;k++){b[k][d][A]=k===e?1:k===c?0:-1;if(k!=e)if(k==c&&(a.c=="zoom"||a.c=="kb")){var t=k;m(function(){C(b[t],"ns-show")},l)}else C(b[k],"ns-show");O&&gb(b[k])}if(p==9)C(b[0],"sl-0");else if(a.c=="slide"||h||a.m&&p){!p&&o(b[e],"ns-show");var n=!h&&j.offsetWidth==g[y].offsetWidth?"2":"",f=e-c;if(!a.rewind){if(!e&&c==r-1)f=1;if(!c&&e!=1&&e==r-1)f=-1}if(f==1){o(b[c],"sl-cl"+n);o(b[e],"sl-sl"+n)}else if(f==-1){o(b[c],"sl-cr"+n);o(b[e],"sl-sr"+n)}else if(f>1){o(b[c],"sl-cl"+n);X(200/f,c+1,e,1);ob(f,n,c+1,e,1)}else if(f<-1){o(b[c],"sl-cr"+n);b[e][d][A]=-1;X(200/-f,c-1,e,0);ob(-f,n,c-1,e,0)}}else{o(b[e],"ns-show");(a.c=="zoom"||a.c=="kb")&&b[e].nI&&i.a.insertRule&&ib(b[e].nI,e,b[e].dL)}Cb(e);var q=c;c=e;lb(4);!j.vR&&jb(b[e]);if(a.d){var s=Math.abs(f)>1?200:0;T=m(function(){tb(e+1,0)},b[e].dL+s)}b[e].player&&mb(b[e]);a.before&&a.before(q,e,p==9?false:p)};ub.prototype={b:function(){var f=g.children,d;r=f[e];for(var c=0,h=f[e];c<h;c++){b[c]=f[c];b[c].ix=c;d=E(b[c],"data-delay");b[c].dL=d?parseInt(d):a.e}},c:function(){Qb(g);this.b();var d=0;if(a.shuffle){for(var i=Wb(b),c=0,k=i[e];c<k;c++)g.appendChild(i[c]);d=1}else if(a.startSlideIndex){for(var j=a.startSlideIndex%b[e],c=0;c<j;c++)g.appendChild(b[c]);d=1}d&&this.b();if(a.c!="slide"&&!h&&a.m){var f=r;while(f--)x(b[f],"animationend",Gb)}},d:function(){if(a.g.indexOf(":")!=-1){var b=a.g.split(":");if(b[1].indexOf("%")!=-1){j.vR=parseInt(b[1]);j[d][F]=j.vR*k[P].clientHeight/100+"px";g[d][F]=g[y][d][F]="100%";return}var c=b[1]/b[0];g[d][L]=c*100+"%"}else g[d][L]="50.1234%";g[d][F]="0"},e:function(b,d){var c=t+b,a=k.getElementById(c);if(!a){a=k.createElement("div");a.id=c;a=g[y].appendChild(a)}if(b!="-pager"){a.onclick=d;Z&&a[u]("touchstart",function(a){a.preventDefault();a.target.click();sb(a)},false)}return a},addNavs:function(){if(r>1){var h=this.e("-pager",0);if(!pb(h)[e]){for(var i=[],a=0;a<r;a++)i.push('<a rel="'+a+'">'+(a+1)+"</a>");h.innerHTML=i.join("")}w=pb(h);for(var a=0;a<w[e];a++){if(a==c)w[a][f]="active";w[a].onclick=function(){var a=parseInt(E(this,"rel"));a!=c&&n(a,1)}}U=this.e("-prev",eb);M=this.e("-next",eb);xb=this.e("-pause-play",Q)}var g=j.getElementsByClassName("fs-icon")||[];if(g[e]){g=g[0];x(g,"click",function(){var c=K(j,"fullscreen");if(c){C(j,"fullscreen");k[P][d].overflow="auto"}else{o(j,"fullscreen");k[P][d].overflow="hidden"}typeof fsIconClick=="function"&&fsIconClick(c,j);c=!c;for(var a,f=0;f<b[e];f++){a=b[f];if(a.nIs)if(a.nI.tagName=="IMG")a.nI.src=a.nIs[c?1:0];else a.nI[d][R]="url('"+a.nIs[c?1:0]+"')"}});x(k,"keydown",function(a){a.keyCode==27&&K(j,"fullscreen")&&g.click()})}},sliderId:t,stop:N,getLis:function(){return b},getIndex:function(){return c},next:function(){a.d&&n(c+1,0)}};var W=function(){j=k.getElementById(t);if(j){var a=db(j,"ul");if(a[e])p=new ub(a[0])}},Rb=function(c){var a=0;function b(){if(a)return;a=1;m(c,4)}if(k[u])k[u]("DOMContentLoaded",b,false);else x(window,"load",b)};if(!a.initSliderByCallingInitFunc)if(k.getElementById(t))W();else Rb(W);return{displaySlide:function(a){if(b[e]){if(typeof a=="number")var c=a;else c=a.ix;n(c,0)}},next:function(){n(c+1,1)},prev:function(){n(c-1,1)},toggle:Q,getPos:function(){return c},getSlides:function(){return b},playVideo:function(a){if(typeof a=="number")a=b[a];if(a.player){n(a.ix,0);p.playVideo(a.player)}},init:function(a){!p&&W();typeof a!="undefined"&&this.displaySlide(a)}}}
				  
				  $('#modalfile').val("");
				  $('#mediaLink').val("");
				  $("#overlay").fadeOut(300);
				 }
			}).done(function() 
			    	{
			    		setTimeout(function() 
			    		{
			    			$("#overlay").fadeOut(300);
			    		}, 500);
    	});
});
document.addEventListener("DOMContentLoaded", function() 
{
    setTimeout(function() 
    {
        document.getElementById("zipcode").value = "";
    }, 100);
});

$(document).on("change", ".validateEmail", function()
{
	let email = $(this).val();
	let pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
 	if (pattern.test(email)) 
	{
	  	$('#emailError').text('');
	  	$('#emailInventorError').text('');
	  	$('#emailVendorError').text('');
	} 
	else 
	{
	  	$('#emailInventorError').text('Invalid email format');
	  	$('#emailVendorError').text('Invalid email format');
	  	$('#emailError').text('Invalid email format');
	  	$(this).val('');
	}
});

$(document).on("click", ".patent-portfolio", function()
{
	let id = $(this).data('id');
	$('#patent-portfolio-preview'+id).modal("show");
});


$(document).ready(function() 
{
    $('.inventor-signup-tab, .vendor-signup-tab').on('input', '.password-input, .confirm-password-input', handlePasswordInput);
    $('.signuptype-inventor, .signuptype-vendor').on('change', handleTabChange);
    $('input[name="user_type"]:checked').trigger('change');

});

function handlePasswordInput() 
{
    const tabContainer = $(this).closest('.tab-container');
    const passwordInput = tabContainer.find('.password-input');
    const confirmPasswordInput = tabContainer.find('.confirm-password-input');
    const matchIndicator = tabContainer.find('.match-indicator');
    const ruleUppercase = tabContainer.find('.rule-uppercase');
    const ruleLowercase = tabContainer.find('.rule-lowercase');
    const ruleNumber = tabContainer.find('.rule-number');
    const ruleSymbol = tabContainer.find('.rule-symbol');
    const ruleLength = tabContainer.find('.rule-length');

    const password = passwordInput.val();
    const confirmPassword = confirmPasswordInput.val();
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSymbol = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password);
    const hasMinLength = password.length >= 8;

    updateStyle(ruleUppercase, hasUppercase);
    updateStyle(ruleLowercase, hasLowercase);
    updateStyle(ruleNumber, hasNumber);
    updateStyle(ruleSymbol, hasSymbol);
    updateStyle(ruleLength, hasMinLength);

    if (hasUppercase && hasLowercase && hasNumber && hasSymbol && hasMinLength) 
    {
        const passwordsMatch = password === confirmPassword;
        updateMatchIndicator(passwordsMatch, tabContainer);
    } 
    else 
    {
        resetMatchIndicator(tabContainer);
    }
    
}

function handleTabChange() 
{
    const tabContainer = $(this).closest('.btn-group').siblings('.tab-container');
    tabContainer.find('.password-input, .confirm-password-input').trigger('input');
}

function updateStyle(element, isValid) 
{
    if (isValid) 
    {
        element.addClass('text-success');
        element.removeClass('text-danger');
    } 
    else 
    {
        element.addClass('text-danger');
        element.removeClass('text-success');
    }
}

function updateMatchIndicator(match, tabContainer, passwordInput, confirmPasswordInput) 
{
    const matchIndicatorElement = tabContainer.find('.match-indicator').eq(0);
    if (match) 
    {
        matchIndicatorElement.addClass('text-success');
        matchIndicatorElement.removeClass('text-danger');
        matchIndicatorElement.html('Passwords match');
        localStorage.setItem('passwordsMatch', true);
        tabContainer.find('.password-input').addClass('is-valid');
        tabContainer.find('.password-input').removeClass('is-invalid');
    } 
    else 
    {
        matchIndicatorElement.addClass('text-danger');
        matchIndicatorElement.removeClass('text-success');
        matchIndicatorElement.html('Passwords do not match');
        tabContainer.find('.password-input').removeClass('is-valid');
        tabContainer.find('.password-input').addClass('is-invalid');
        localStorage.setItem('passwordsMatch', false);

    }
}

function resetMatchIndicator(tabContainer) 
{
    const matchIndicatorElement = tabContainer.find('.match-indicator').eq(0);
    matchIndicatorElement.removeClass('text-success text-danger').html('');
    tabContainer.find('.password-input').removeClass('is-valid');
    tabContainer.find('.password-input').addClass('is-invalid');
}

$(document).on("click", ".vendorprofileslider", function()
{
	let id = $(this).data('fid');
	$('.freevendorsliderfileupload').click();
});

